

export const SCHEME_MEDICINE_LIST = `
3 CEF NOVO 375 VIAL CC VIALS	VIAL5+1
3 CEF NOVO 375INJ 2ML	PCS5+1
3 CEF NOVO 750 VAIL 1 VIAL	VIAL5+1
3CEF NOVO 750 5ML	PCS5+1
A TO Z 200ML SYP 1X200ML	PH5+1
A TO Z GOLD 15CAP	PCS9+1
A TO Z GOLD 1X15	STP10+1
A TO Z NS SYP 100ML	PCS9+1
A TO Z NS SYP LARGE 200ML	PCS5+1
A TO Z NS TAB 1X15T	PCS9+1
A TO Z ORS 21.5GM	SCHT9+1
A TO Z ORS 4.3GM	SCHR9+1
A TO Z SYR 100ML	SYR9+1
A TO Z SYRUPS 1X100ML	PH9+1
ABTHER-INJ 150MG 2ML AMP	AMP9+1
ABTHER-INJ 75MG 1ML AMP	AMP9+1
ALCIPRO 250MG STRIP TABS 1X10	STRP9+1
ALCIPRO 250MG TAB 1X10	PCS7+3
ALCIPRO 500MG TAB 1X10	PCS9+1
ALCIPRO 500MG TABS 30X10	BOX9+1
ALCIPRO 750MG STRIPS 1X10	STRP9+1
ALCIPRO 750MG TAB 1X10	PCS9+1
ALCIPRO TAB 250MG 10T	PCS9+1
ALCIPRO TAB 500MG 10T	PCS9+1
ALCIPRO TN TAB 1X10	PCS5+1
ALCIPRO-OD 1000 1X5	PCS10+5
ALCIPRO-TN TABS 20X10	PCS5+1
ALERT-L 110	TAB9+1
ALKEL SYP 100ML	SYPT9+1
ALKEMZYME SYP 1X200	PH4+1
ALKEMZYME SYP 1X200ML	PCS9+1
ALPROVIT ACTIVE 200GMS	PCS9+1
ALPROVIT ACTIVE 200GRAM 200GRM	PCS9+1
ALPROVIT GR POWDER 200GM	PCS9+1
ALPROVIT JUNIOR 200GM	PCS9+1
ALPROVIT MILK-MASALA 200GM	PCS9+1
ALPROVIT PLUS SYP 1X200ML	PH10+1
ALPROVIT PLUS SYP 200ML	PCS9+1
ALPROVIT PLUS SYRUPS 1X200ML	PCS5+1
ALPROXEN TAB 200 1X10	PCS9+1
ALPROXEN-I/V 100ML	PCS1+1
ALPROXEN-O 1X10	PCS5+1
ALZYME SYP 200ML	PCS23+7
AMITAX 100 1VAIL	PCS10+6
AMITAX 100MG VAIL 1X2ML	PCS10+6
AMITAX 100MG VAIL VIAL	PCS10+6
AMITAX 250 1VAIL	PCS10+4
AMITAX 250MG VAIL 1 VAIL	PCS10+4
AMITAX 250MG VAIL VIAL	PCS10+4
AMITAX 500 VAIL 1VAIL	PCS1+1
AMITAX 500MG VAIL VIAL	PCS1+1
AMLOKIND AT 1X10	PCS11+1
BALOKEM TABS 10X10	BOX9+1
BROADICILIN 100MG VAIL 1X1	VIAL9+1
BROADICILIN 100MG VAIL VAIL	PCS9+1
BROADICILIN 250MG CAPS 10X10	BOX9+1
BROADICILIN 250MG VAIL VAIL	PCS10+3
BROADICILIN 500 CAPS 10X10	BOX9+1
BROADICILIN 500 VIALS 1X1	VIAL9+1
BROADICILIN 500CAPSULES 1X10	PCS9+1
BROADICILIN 500MG VAIL VAIL	PCS9+1
BROADICILIN CAP 500MG 10CAP	9+1
BROADICILIN DROP 10ML	PCS9+1
BROADICILIN DROPS 1X10ML	PCS9+1
BROADICILIN DROPS 10ML	PCS688+80
BROADICILIN DRY SYRUP 1X30ML	PCS9+1
BROADICILIN VAIL 100 1VAIL	PCS9+1
BROADICILIN VAIL 500MG 1VAIL	PCS9+1
BROADICLOX 1GM VAIL VAIL	PCS19+1
BROADICLOX LB 500 1X10	PCS4+1
BRODICLOX 250MG VAIL 1 VAIL	PCS9+1
BRODICLOX 250MG VAIL VAIL	PCS19+1
BRODICLOX 500MG CAP 1X10	PCS19+1
BRODICLOX 500MG CAPS 10X10	PCS19+1
BRODICLOX 500MG VAIL VAIL	PCS19+1
BRODOCILLIN 250MG CAP 1X10	PCS4+1
BRODOCILLIN SYP. 30ML	PCS3+1
BUDASURE PULMULES 2ML	PCS3+1
CALCIPERL SYP 150ML	PCS9+1
CALCIPERL TAB 115	PCS9+1
CARNIMED PLUS 1X10	TAB10+1
CEFAST 1000 MG VAIL	PCS100+45
CEFAST 125MG	PCS4+1
CEFAST 250MG VIAL	PCS10+8
CEFAST 500MG VIAL	PCS4+1
CEFAST-MAX 1.50 VIAL	VIAL34+16
CEFAST-MAX 375 INJ 5ML	PCS10+4
CEFAST-MAX 750 VIAL	VIAL19+6
CEFOKEM-XP 1G 5ML	VIL10+4
CEFOKEM-XP 2G 5ML	VIL10+5
CEFOKEM-XP 500 5ML	VIL2+1
CEFOXID DROPS	PCS5+1
CEHAM INJ 250MG 1X5ML	BOX14+6
CETIRIZ 10MG TABS 50X10	BOX9+1
CETIRIZ 30ML SYRUPS 1X30ML	PHIL9+1
CETIRIZ 60ML SYP 1X60ML	PCS9+1
CETIRIZ SYP. 60ML	PCS9+1
CETIRIZ TAB 10TAB	9+1
CETIRIZ TAB 1X10	PCS9+1
CHINGASU INJ 2ML	PCS9+1
CILAXTER 125VIL 5ML	VIL5+1
CLAVAM 1.2GM. VAIL VAIL	PCS10+4
CLAVAM 150 VIAL VIAL	PCS9+1
CLAVAM 150MG VAIL 1VAIL	PCS9+1
CLAVAM 150MG VIAL 1 VIAL	VaiL9+1
CLAVAM 300 VIAL VIAL	PCS9+1
CLAVAM 300MG VAIL 1VAIL	PCS9+1
CLAVAM 300MG VIAL 1 VIAL	VIAL9+1
CLAVAM 375MG 1X10 TABS 1X10	STRP9+1
CLAVAM 375MG TAB 10TAB	PCS9+1
CLAVAM 600 VAIL 1VAIL	PCS21+4
CLAVAM 600 VIL 5ML	PCS21+4
CLAVAM 625 TAB 10TAB	PCS5+1
CLAVAM 625MG 1X10 TABS 1X10	STRP5+1
CLAVAM 625MG TAB 1X10	PCS5+1
CLAVAM BID DRY SYP 30ML	PCS5+1
CLAVAM BID SYP 30ML	PCS5+1
CLAVAM BID SYRUPS 1X30ML	PCS5+1
CLAVAM DROP 1X10ML	PH5+1
CLAVAM DROP 1X10ML	PCS5+1
CLAVAM DROPS 1X10ML	PCS5+1
CLAVAM DRY SYP 30ML	PCS5+1
CLAVAM DRY SYRUPS 1X30ML	PCS5+1
CLAVAM DT STRIP TABS 1X10	STRI9+1
CLAVAM FORTE DRY SYP 1X30ML	PH5+1
CLAVAM FORTE DT TABS 1X10	STRP9+1
CLAVAM FORTE SYP 1X30ML	PCS5+1
CLAVAM FORTE SYP 30ML	PCS5+1
CLAVAM LB D/SYP 30ML	PCS9+1
CLAVAM LB DRY SYP 1 PH	PCS5+1
CLAVAM SYP. 30ML	PCS5+1
CLAVAM-LB 375 1X10	PCS5+1
CLAVAM-LB 625 1X10	PCS10+3
CLAVAM-LB 625MG TAB 1X10	PCS19+6
CLAVPOD 325 DT 1X10	STP9+1
CLAVPOD 325 TAB 1X10	STRP9+1
CLAVPOD 50 SYP 30ML	PCS9+1
CLOPEP SYRUP 160ML	PCS5+1
COLPEP DROP 15ML	PCS9+1
COLPEP DROPS 1X15ML	BOX9+1
COLPEP SUSPENSION 1x30	PH9+1
COLPEP SYP 30ML	PCS9+1
CRIZ M SYP 1X60ML	PH9+1
CRIZ M TAB 10X10	BOX9+1
CRIZ SYP 100ML	PCS9+1
CRIZ-M 10TAB	9+1
CRIZ-M SYP 60ML	9+1
CRIZ-M SYRUP 60ML	SYP9+1
DIET PROTEIN POWDER 1200GM	PCS9+1
DIET PROTEIN SYP 200ML	PCS9+1
DIGIPEN CAP 1X10	TAB9+1
DIGIPEN DROP 15ML	PCS9+1
DIGIPEN DROP 15ML	DROP9+1
DIGIPEN DROP 15ML 1X15ML	PH9+1
DIGIPEN JUNIOR SYP 1X60ML	PHL.9+1
DIGIPEN JUNIOR SYP 60ML	PCS9+1
DIGIPEN JUNIOR SYP 80ML	STP9+1
DIGIPEN SYP 200ML	PCS11+1
DIGIPEN SYP 200ML	PCS11+1
DIGIPEN SYRUP 200ML 1X200ML	PHL11+1
DIGIPEN TAB 10TAB	9+1
DIGIPEN TAB 10X10	BOX9+1
DYDROSURE 10MG 10TAB	PCS5+1
EASCOF LS SYP 100ML	SYP9+1
EASCOF-D SYP 100ML	SYP5+1
EFIMOX ER 1X5	TAB9+1
EMTY (LACTULOSE SYP 200ML	PCS9+1
EMTY 100ML SYP 1X100ML	PH9+1
EMTY SYP 100ML	SYPT9+1
EMTY SYP 100ML	PCS9+1
EMTY SYP 200ML	PCS9+1
ENZOFLAM SP 1X10	PCS9+1
ENZOFLAM SP TAB 1X10	STRP9+1
ENZOFLAM TAB 10TAB	PCS19+1
ENZOFLAM TAB 1X10	PCS19+1
ENZOFLAM TABS 30X10	BOX19+1
ENZOFLAM-P TABLETS 1X10	PCS9+1
ESCOF LS SYP 100ML	PCS9+1
ESCOF-D SYP 100ML	PCS5+1
FENCETA MR 4 TAB 10X10	BOX9+1
FENCETA NOVO 110	TAB9+1
FENCETA NOVO 325 TAB 30X10	BOX9+1
FENCETA PLUS SYP 1X60ML	PHL14+1
FENCETA PLUS SYP 60ML	TAB14+1
FENCETA SP TAB 110	TABS9+1
FENCETA SPAS TAB 10X10	BOX9+1
FENCETA SYP. 60ML	PCS9+1
FENCETA SYRUPS 1 PH	PCS9+1
FENCETA TAB 1X10	PCS14+1
FENCITA M SYP 60ML	PCS9+1
FENCITA NOVO 10TAB	PCS9+1
FENCITA PLUS SYP 60ML	15+1
FENCITA-M SYP 60ML	SYP9+1
FENCITA-SPAS 1X10	CAP9+1
FEROFAST TAB 1X10	STP9+1
FUNGIKEM 100 1X7	TAB5+1
FUNGIKEM 100 STRIP CAP 1X10	STRP79+41
FUNGIKEM 200 7CAP	PCS2+1
FUNGIKEM 200 STRIP CAP 1X7	STRI9+1
FUNGIKEM-200 1X4	TAB5+1
GEMCAL GRO SYP 1X200ML	PHL.9+1
GEMCAL GRO SYP 200ML	SYP9+1
GEMCAL GRO SYP 200ML	PCS9+1
GEMCAL P SUP 150ML	PCS9+1
GEMCAL P SYP 1X150ML	PH9+1
GEMCAL P SYP 150ML	SYPT9+1
GUTGAIN SUSPENSION 5ML	PCS9+1
HEMFER AMP 1X5ML	1+1
HEMFER INJECTION 1X5ML	STP1+1
HEMFER KID SYP 100ML	9+1
HEMFER SUP 225ML	4+1
HEMFER SYP. 225ML	PCS4+1
HEMFER SYP(300) 300ML	SYP5+1
HEMFER SYRUPS 1X225ML	PH4+1
HEMFER XT TAB 110	TAB9+1
HEMFER-XT 10TAB	9+1
HEMFER-XT TAB 10X10	BOX9+1
INDIKOF A SYP 1X100ML	PH9+1
INDIKOF A PLUS 100ML	PCS9+1
INDIKOF A SYP 100ML	PCS9+1
INDIKOF B SYP 100ML	PCS9+1
INDIKOF B SYP 100ML	PCS9+1
INDIKOF C SYP 100ML	PCS9+1
INDIKOF LS 100ML	PCS9+1
INDIKOF LS SYP 1X60ML	PCS9+1
IPRASURE PULMULES 2.5ML	PCS9+1
JAKFER(IRON SYP)200ML 1200ML	PCS4+1
JAKFER(IRON SYP)300ML 1300ML	PCS4+1
JEEVANPRASH 1000GM	PH3+1
JEEVANPRASH 200GM	PH11+1
JEEVANPRASH 500GM	PH11+1
L-CETIRIZ SYP 30ML	9+1
L-CETIRIZ TAB 10TAB	9+1
LEVOZ INJ. 1AMP.	PCS5+1
LINOKEM 600 10CAP	PCS9+1
LINOKEM 600 1X10	TAB9+1
LINOKEM 600 TAB 1X10	STRP9+1
LORSUMO PLUS 110	TAB9+1
LULIHALT CREAM 10GMS	PCS10+3
MAGTAM 0.5GM VIAL	PCS37+8
MAGTAM 2GM. VIAL	PCS5+1
MAGTAM NOVO 1.5 10ML	VIL10+5
MEGANOR OZ SYP 30ML	PCS9+1
MEGANOR SYP 30ML	SYP9+1
MEGANOR SYRUPS 1X30ML	PCS9+1
MEGANOR TABS 10X10	BOX9+1
MEGANOR-02 110	TAB9+1
MEGAPIME 500MG VIAL	PCS5+1
MEGAPIME 1GM. VIAL	PCS5+1
MEGAPIME 250MG VIALS CC VIALS	PCS9+1
MEGAPIME XP 250 1VAIL	PCS5+1
MEGAPIME-250 VIAL	PCS5+1
MEROSURE 125KIT 5ML	INJC10+3
MEROSURE 250 INJ 5ML	INJT5+1
MEROSURE 250 VIAL 1X1	PH10+3
MEROSURE 500 VIAL 1X1	VIAL10+3
MEROSURE KIT 125 VIAL 1X1	VIAL10+6
MEROSURE SB 1 5GM VIAL 1X1	VIAL10+5
MEROSURE-1GM KIT 5ML	INJ10+5
MEROSURE-500KIT 5ML	INJ9+1
MEROSURE-BS-1.5 10ML	VIL10+5
MEROSURE-O ER 300 1X6	CAP5+1
MEROSURE-O ER300 6TAB	PCS5+1
MEROSURE-O TAB 1X9	TAB5+1
MEROSURE-O TAB 6TAB	5+1
METRON DF TAB 1X15	PCS9+1
METRON DF TABS 20X15	PCS9+1
MIKATAX 100INJ 12ML	PCS9+3
MIKATAX 250 INJ 12ML	PCS10+4
MIKATAX 500 INJ 12ML	PCS1+1
MOVACE PLUS 16TAB	PCS9+1
NAKUF NAKOLD SYP 100ML	SYP4+1
NAKUF NAKOLD TAB 110	TAB4+1
NERV DX 20 1X10	STP10+3
NERV DX 30 1X10	STP10+3
NEW TOTALDERM CREAM 1X10GM	TUBE5+1
NODICLOX-500 CAPSULES 110'S	STP9+1
NODIMOX PLUS 250 DT TABS 10X10	BOX19+1
NODIMOX PLUS 250MG 1X10	PCS19+1
NODIMOX PLUS 500 10CAP	PCS9+1
NODIMOX PLUS 500 CAP 20X10	BOX9+1
NODIMOX PLUS 500 CAP. 110	STP19+1
NODIMOX PLUS KID 10TAB	9+1
NODIMOX PLUS-LB 500MG	PCS9+1
NODIMOX-LB 500MG TAB. 1X10	PCS9+1
NOVOGERMINA 10AMP	PCS9+1
NOVOGERMINA 5ML 5ML	TAB9+1
NOWARM SYP 15ML	19+1
NOWARM TAB 1TAB	19+1
NOWORM SUSPENSION 1X10ML	PCS19+1
NOWORM SYP. 10ML	PCS19+1
NOWORM TAB 1X1STP	PCS19+1
NOWORM TABS STRIP 1X1TABS	STR19+1
NOZUKA AF SYP 1X60ML	PH0+1
NOZUKA SYP 60ML	SYP9+1
NULOC D CAP 1X10	STRP9+1
NULOC I.V. 1X20MG	I.V.9+1
NULOC MPS SYP 1X200ML	PH11+1
NULOC MPS SYP 200ML	PCS11+1
NULOC-20 1X10	PCS9+1
OMEPRAZ 20MG CAP 1X10	PCS7+3
ONDEM 20X2ML AMP 20X2ML	BOX1+1
ONDEM 2ML AMP AMP	PCS1+1
ONDEM 4ML AMP 50X4ML	BOX1+1
ONDEM 50X2ML AMP 50X2ML	BOX1+1
ONDEM AMP 1AMP	PCS1+1
ONDEM SYP 30ML	PCS9+1
ONDEM SYP 30ML	PCS9+1
ONDEM SYRUPS 1X30ML	PCS9+1
OVSTORE SR 1X10	TAB10+1
PAN MPS 200ML	PCS5+1
PAN MPS SYP 1X200ML	PH5+1
PAN MPS SYP 200ML	SYP5+1
PAN MPS-O SYP 200ML	PCS11+1
PAN MPS-O SYP 200ML	SYP11+1
PAN-40 INJ VIAL	PCS10+5
PIPZO 1 125 1VAIL	PCS5+1
PIPZO 1 125 VIAL 1X1	VIAL166+34
PIPZO 2 25 GM 1VAIL	PCS5+1
PIPZO 2 25GM 1X1	PHL166+34
PIPZO 2.25 5ML	INJ5+1
PIPZO 4.5 INJ VIAL	PCS10+8
PIPZO-1.125 VIAL	VIAL5+1
POVIROBES OINT 15GM	OINT5+1
POVIROBES OINT 15GMS	PCS5+1
PRATHAM 100 DT TAB 13	PCS9+1
PRATHAM 200 SYP 1X15ML	PH9+1
PRATHAM 500 TAB 2X5	BOX9+1
PRATHAM500MG 1X5	STP9+1
PREGCLEAR TAB 10X4	BOX2+1
PREGCLEAR TAB 14	PCS2+1
PRIMEOVA 100CAP 1X5	TAB10+1
PRULASTIN M SYRP 1X1	PCS9+1
PRULASTIN-M 10TAB	PCS9+1
PRULASTIN-M SYP 60ML	PCS9+1
PRULASTIN-M SYP 60ML	PCS9+1
PRULASTIN-M TAB 1X10	STRP9+1
PRULASTIN-M TABLET 1X10	PCS9+1
PUC 650 10TAB	PCS10+3
PUC DROP 15ML	PCS11+1
PUC SYP 120MG 60ML	PCS9+1
PUC SYP 250 60ML	PCS5+1
PULMOSMART 1MG 2ML	PCS4+1
PULMOSMART 2ML	PCS4+1
RAPEED 20 STRIP TAB 1X15	STRP9+1
RAPEED-20 15TAB	PCS5+1
RAPEED-20MG 1X10	PCS9+1
RAPEED-D 10CAP	PCS5+1
RAPEED-D 1X10	PCS9+1
RAPEED-D CAP 10X10	BOX83+17
REVOTAZ 1.125 1X1VAIL	TAB9+1
REVOTAZ 4.5GM VIAL	VIAL10+4
RHAMO G SACHETS 1GM	PCS9+1
RHAMO G SCH 1SCH	PCS5+1
RIFAKEM 200 TAB 1X10	PCS9+1
RIFAKEM 400 TAB 1X10	STR9+1
RIFAKEM 550 1X10	PCS9+1
RONFLOX 200 110	PCS10+3
RONFLOX 200MG TABS 20X10	BOX5+1
RONFLOX 400 110	TAB9+1
RONFLOX OZ TAB 1X10	PCS5+1
RONFLOX OZ TABS 10X10	BOX21+4
ROSITA XT SYP 150ML	PCS9+1
ROSITA XT TAB 110	PCS9+1
SOLUFER SYP 150ML	PCS9+1
SOLUFER TAB 1X10	STP9+1
SORBACID GEL 170ML	PCS5+1
SORBACID O GEL 1X170ML	PH10+1
SORBACID SYP 170ML	5+1
SORBACID SYRUPS 1X200ML	PCS11+1
SUMO 15TAB	PCS5+1
SUMO ACE 10TAB	PCS3+1
SUMO COLD 1X10	STP5+1
SUMO COLD AF SYP 60ML	PCS9+1
SUMO COLD DROP 10ML	DROP9+1
SUMO COLD PCF DROPS 1X10ML	PH9+1
SUMO COLD PCF SYP 60ML	SYP9+1
SUMO COLD PCF SYRUPS 1X60ML	PH9+1
SUMO COLD TAB 20X10	BOX83+17
SUMO GEL 1X30GM	TUBE9+1
SUMO GEL 30GM	PCS9+1
SUMO L 125 60ML SYP 1X60ML	PH9+1
SUMO L 125 SYR 1X30ML	CAP9+1
SUMO L 250MG DS SUS 1X60ML	PCS5+1
SUMO L 650ER 1X10	TAB10+3
SUMO L DROP 15ML	DROP23+2
SUMO L DS 30ML SYP 1X30ML	PH5+1
SUMO L DS SYP 60ML	SYP5+1
SUMO L PLUS DS SYRP 1X100ML	PCS9+1
SUMO L PLUS SYP 1X60ML	PH9+1
SUMO L TAB 110	TAB9+1
SUMO MF SUSPENSION 1X60ML	PH9+1
SUMO MF SYP 60ML	SYP9+1
SUMO SPRAY 1X50GM	PH5+1
SUMO SPRAY(50GMS) 50GM	TAB5+1
SUMO TAB 1X10	PCS9+1
SUMO TAB-15TAB 115	TAB5+1
SUMO TABS 20X15	BOX83+17
SUMO-JOY 1X10	TAB9+1
SUMO-L 100MG DROP 1X15ML	PHIL184+16
SUMO-L 120 SYP 60ML	PCS9+1
SUMO-L 125 SYP 60ML	SYPP9+1
SUMO-L 250 DS SYP 60ML	5+1
SUMO-L 650 TAB 20X15	BOX9+1
SUMO-L 650MG 15TAB	10+3
SUMO-L DROP 15ML	11+1
SUMO-L PLUS DS SYP 100ML	PCS9+1
SUMO-L PLUS SYP 60ML	9+1
SUMO-L PLUS(60ML) 60ML	SYP9+1
SUMOCOLD AF SYP 60ML	PCS9+1
SUMOCOLD DROP 10ML	PCS9+1
SUMOCOLD PCF SYRUP 1X60ML	PCS9+1
SUMOCOLD TAB 1X10T	PCS5+1
SUMOFLAM TAB 15TAB	PCS9+1
SUMOFLAM TAB 1X10	PCS9+1
SUMOFLAM TABS 20X15	BOX9+1
SWICH 100MG SYP 30ML	9+1
SWICH 100MG SYP 1X30ML	PHL.9+1
SWICH 200 1X6	PCS9+1
SWICH 200 TABS 10X10	BOX9+1
SWICH 200MG 10TAB	5+1
SWICH 50 DT 1X10	PCS9+1
SWICH 50MG DRY SYRUP 1X30ML	PCS9+1
SWICH 50MG SYP 30ML	9+1
SWICH CV 100 SYP 1X30ML	PH9+1
SWICH CV 325MG TAB 1X10	STRP9+1
SWICH CV 50 SYP 1X30ML	PH9+1
SWICH CV 50 SYP 30ML	SYPL9+1
SWICH DROP 10ML	9+1
SWICH DROPS 1X10ML	PH9+1
SWICH DROPS 10ML	TAB9+1
SWICH-100 SYP 30ML	PCS9+1
SWICH-200MG 1X10	STP167+33
SWICH-50 SYR 30ML	PCS9+1
SWICH-CV 100 SYP 30ML	9+1
SWICH-CV 325 10TAB	9+1
SWICH-CV 50 SYP 30ML	9+1
SWICH-CV325 110	TAB9+1
SWICH-XP 1000 1VAIL	PCS1+1
SWICH-XP 1000MG VIAL 1 VIAL	PCS10+8
SWICH-XP 125 5ML	VIL21+4
SWICH-XP 125MG 1VAIL	21+4
SWICH-XP 125MG VAIL 1X1	VIAL126+24
SWICH-XP 1GM VIAL	VIAL1+1
SWICH-XP 250MG 1VAIL	10+12
SWICH-XP 250MG VIAL	VIAL11+9
SWICH-XP 500MG 1VAIL	PCS2+1
SWICH-XP 500MG VIAL	VIAL7+3
TAXIM 125MG 1VAIL	PCS5+1
TAXIM 125MG VAIL VAIL	PCS9+1
TAXIM 125MG VIALS CC VILAS	PCS415+85
TAXIM 1GM VAIL 1VAIL	PCS5+1
TAXIM 1GM VAIL VAIL	PCS9+1
TAXIM 1GM VIAL CC VIALS	PCS83+17
TAXIM 2 GM 1X1	PCS9+1
TAXIM 250 VIAL 1X1	VIAL5+1
TAXIM 250MG VAIL 1VAIL	PCS5+1
TAXIM 250MG VAIL VAIL	PCS9+1
TAXIM 500 VIAL 1X1	VIAL5+1
TAXIM 500MG VAIL 1VAIL	PCS5+1
TAXIM 500MG VAIL VAIL	PCS9+1
TAXIM O 100DT TAB 10TAB	9+1
TAXIM O 50MG TAB 10TAB	9+1
TAXIM O CV 200 110	TAB9+1
TAXIM O FORT SUSP 1X60ML	PHL9+1
TAXIM O FORTE SYP 1X30ML	PH9+1
TAXIM O FORTE SYP 30ML	PCS9+1
TAXIM OF TAB 10X10	BOX9+1
TAXIM-AZ 100 10TAB	11+1
TAXIM-AZ 200 10TAB	5+1
TAXIM-O DRY SYP 1X60ML	PHL.9+1
TAXIM-O DRY SYRUPS 1X30ML	PH9+1
TAXIM-O DT 100MG TAB 10X10	BOX9+1
TAXIM-O DT 50MG 1X10	PCS9+1
TAXIM-O FORTE SYP 60ML	PCS9+1
TAXIM-OF 10TAB	PCS9+1
TAXIM-OF TAB 110	SYP9+1
TAXIMAX 1500MG VIAL 1X1	VIAL9+1
TAXIMAX 375 VIAL 1X1	VIAL9+1
TAXIMAX 750 VIAL 1X1	VIAL9+1
TAXIMAX VAIL 1500MG 1VAIL	PCS9+1
TAXIMAX VAIL 375MG 1VAIL	PCS9+1
TAXIMAX VAIL 750MG 1VAIL	PCS9+1
TAXIMAX-1500 VIAL	VIAL9+1
TAXIMAX-375 VIAL	VIAL9+1
TAXIMAX-750 VIAL	VIAL9+1
TAZID 125 VAIL 1VAIL	9+1
TAZID 125 VAIL 1X125MG	TAB9+1
TAZID 125 VIAL 1X1	VIAL9+1
TAZID 1GM VIAL 1X1	VIAL9+1
TAZID 250 VIAL 1X1	VIAL9+1
TAZID 250MG VAIL 1VAIL	PCS9+1
TEGLIPT TAB 1X15	TABS5+1
TERMIPIL TAB 1TAB	PCS1+3
TERMIPIL TABS 10X1	BOX5+1
TOFE C.I SYP 200ML	PCS9+1
TOFE C.I. CAP 1X10	PCS10+1
TOTALDERM CREM 15GMS	PCS5+1
TOTALDERM CREAM 10GM	PCS5+1
TOTALDERM CREAM 1X10GM	TUBE5+1
TOTALDERM POWDER 100GMS	PCS9+1
TOTALDERM+CREAM 1X15GM	PSC5+1
TRINERVE LC CAP 10X10	BOX9+1
TRUMP D SYP 100ML	PCS9+1
TRUMP-A 100ML SYP 1X100ML	PH9+1
TRUMP-A 50ML SYP 1X50ML	PH9+1
TRUMP-A SYP 100ML	SYP9+1
TRUMP-D 100ML SYRUP 1X100ML	PH9+1
TRUMP-D SYP 100ML	SYP9+1
ULTIGEST 200 10CAP	PCS17+3
ULTIGEST SR 200 10TAB	PCS5+1
ULTIGEST SR 300 10TAB	PCS5+1
ULTIGEST SR200 1X10	TAB10+1
V M FORTE TAB 1X10	STRP9+1
V M FORTE TAB 15TAB	PCS9+1
V M NU SYP 100ML	PCS9+1
V M NU SYP 200ML	PCS5+1
VANCOGEN 500MG VAIL VIAL	PCS5+1
XONE 125 VAIL 1VAIL	PCS10+3
XONE 125 VIAL VIAL	PCS10+3
XONE 125MG VIAL 1VIAL	PCS10+3
XONE 1GM INJ 1VAIL	PCS10+10
XONE 1GM VIAL CC VIALS	PCS1+1
XONE 1GM VIAL VIAL	PCS1+1
XONE 250MG INJ 1VAIL	PCS10+6
XONE 250MG VIAL CC VIAL	PCS10+6
XONE 2GM 10ML	VIL10+4
XONE 2GM VAIL 1X1	VIAL71+29
XONE 500MG INJ 1VAIL	PCS10+4
XONE 500MG VIAL 1 VIAL	PCS10+4
XONE 500MG. VIAL	PCS10+4
XONE SB 1GM 1VAIL	PCS10+14
XONE SB 1GM 5ML	VIL10+16
XONE SB 1GM VIL 1X1	VIAL10+16
XONE SB 250 1VAIL	PCS10+5
XONE SB 250 VIAL 1X1	VIAL10+5
XONE SB 250MG 5ML	VIL10+5
XONE SB 500 1VAIL	PCS2+1
XONE SB 500 VIAL 1X1	VIAL10+5
XONE SB 500MG 5ML	VIL10+5
XONE XP KID VIAL 1X1	PCS10+12
XONE-XP 1 125GM VIAL 1 VIAL	PCS10+12
XONE-XP 1 125MG VAIL 1VAIL	PCS10+10
XONE-XP 1.125GM VIAL	VIAL1+1
XONE-XP 125 5ML	INJ21+4
XONE-XP 125MG VAIL 1VAIL	PCS21+4
XONE-XP 125MG VIAL 1VIAL	Pcs21+4
XONE-XP 250MG KID VIAL 1 VIAL	PCS136+164
XONE-XP HS VAIL 1VAIL	2+1
XONE-XP HS VIAL 1 VIAL	PCS10+5
XONE-XP KID VAIL 1VAIL	10+12
XONE-XP KID VIAL	VIAL136+164
XPECT A SYP 1X100ML	PH9+1
XPECT B SYP 1X100ML	PH.4+1
XPECT D SYP 100ML	Pcs9+1
XPECT D SYP 100ML	SYPT9+1
XPECT LS SYP 100ML	PCS9+1
XPECT PD SYP 1X100ML	PH9+1
XPECT-A 100ML	PCS9+1
XPECT-B SYP. 100ML	PCS4+1
XPECT-LS SYP 100ML	PCS9+1
YEES INJECTION 5ML	PCS5+1
ZADONASE F SYP 100ML	PCS9+1
ZADONASE-F SYP 100ML	SYPT9+1
ZENEGRA-100 14	PCS1+5
ZENEGRA-50 TAB 14	PCS1+5
ZINCOCET A SYRUPS 1X100ML	BOX5+1
ZINCOCET SYRUPS 1X100ML	PH5+1
ZINCOCET-A SYP 100ML	PCS9+1
ZINCOCET-P SYP 60ML	PCS9+1
ZINCOCET-P TAB	PCS5+1
ZITHIUM 100 ORAL SYP 15ML	PCS9+1
ZITHIUM 200 DS SYP 15ML	PCS9+1
ZITHIUM 250 TAB 16	PCS9+1
ZITHIUM 250 TABS 1X6	STRP9+1
ZITHIUM 500 5TAB	PCS9+1
ZITHIUM 500 STRIP TAB 4X5	BOX9+1
ZITHIUM 500 TAB 1X5	PCS9+1
ZITHIUM ORAL SYP 15ML	TAB9+1
ZITHIUM XL 100 30ML	PCS9+1
ZITHIUM XL 200 30ML	PCS9+1
ZITHIUM XL 200 30ML	PCS9+1
ZOCEF 1 5GM VIAL 1X1	VIAL4+1
ZOCEF 1.5GM VAIL VAIL	PCS10+4
ZOCEF 250 INJ 1X1	VIL5+1
ZOCEF 250MG TAB 1X10	PCS9+1
ZOCEF 250MG TABS 1X10	PCS47+3
ZOCEF 250MG VIAL VIAL	PCS5+1
ZOCEF 500MG TAB 1X10	PCS9+1
ZOCEF 500MG TABS 1X10	PCS9+1
ZOCEF 750 INJ 1X1	VIAL16+9
ZOCEF 75OMG VIAL VIAL	PCS9+1
ZOCEF DRY SYP 30ML	PCS9+1
ABDEC SUSPENSION 200ML	PCS3+1
ABOVE 5 16	TAB8+1
ABOVE 5D 16	TAB8+1
AGAROL EMULSION VANILLA 120ML	STRI9+1
BECOCUL PERFORMANCE 115	PCS4+1
BECOSULE SYRP 1X200ML	PHL7+1
BECOSULE Z CAP 1X15	PCS24+1
BECOSULES CAP 1X20STRI	TAB24+1
BECOSULES JUNIOR SYP 200ML	SYP9+1
BECOSULES PERFORMANCE 115	BOX4+1
BECOSULES PERFORMANCE 1X15	CAP4+1
BECOSULES PERFORMANCE 1X15	STRP4+1
BECOSULES PLUS CAP 1X30	CAP4+1
BECOSULES Z 1X25	TAB24+1
BECOSULES Z CAPS 25X20	BOX24+1
BECOTROL 10 CAP 110	TAB9+1
BECOTROL CAP 10X10	BOX9+1
BRON COREX SYP.(L) 100ML	PCS19+1
BRON COREX SYP.(S) 50ML	PCS24+1
BRONCOREX 100ML SYP 100ML	PH9+1
BRONCOREX 50ML SYP 50ML	PH9+1
CHLOROMYCETIN 250 CAP 110	TAB9+1
CHLOROMYCETIN 250MG CAP 20X10	BOX5+1
CHLOROMYCETIN 500MG CAP 20X6	BOX5+1
CHLOROMYCETIN APPLICAP 130	PHIL9+1
CHLOROMYCETIN EAR DROP 1X5ML	PCS19+1
CHLOROMYCETIN EYE OINT 1X50	PH.22+3
CHLOROMYCITIN SYP 1 PH	PCS4+1
CITRALKA LIQUID 1X100ML	PH7+1
COREX DX 100ML 1100ML	BOXP9+1
COREX DX 50ML 150ML	TANB9+1
COREX DX SYP. (S)	PCS9+1
COREX DX SYP.(L)	PCS9+1
COREX LS COUGH SYP 1PH	PCS9+1
COREX LS JUNIOR 60ML	SYPC9+1
COREX LS SYP 100ML	SYP9+1
COREX T COUGH SYP 100ML	TAB9+1
COREX T COUGH SYP 50ML	TAB24+1
COREX-DX 100ML SYP 1X100ML	PCS9+1
COREX-DX 50ML SYP 1X50ML	PCS19+1
DOLONAT TAB 110	TAB9+1
DOLONEX 1ML AMP 100X1ML	BOX9+1
DOLONEX 20MG CAP	PCS19+1
DOLONEX 2ML 12ML	INJ6+1
DOLONEX 2ML AMP HOSP PACK 45X2ML	BOX9+1
DOLONEX 2ML INJ 100X2ML	BOX9+1
EQUIFLEX 100 4MG TAB 10X10	BOX9+1
EQUIFLEX 100 8MG TAB 10X10	BOX9+1
EQUIFLEX 4+100 110	TAB9+1
EQUIFLEX 8+100 110	TAB9+1
EQUIO TAB 110	TAB15+2
EXTRENT SYP 100ML	SYP9+1
FELBAN INJ 5X2ML	BOX1+1
FOLVITE ACTIVE TAB 1X10	STRP9+1
FUREA BOLUS 1X6	Pcs11+1
GELUSIL 200ML SYP 200ML	PCS19+1
GELUSIL MPS 200ML	SYP11+1
GELUSIL MPS TAB 110	TAB10+1
GELUSILXTRACOOL SYP 200ML	SYP9+1
HETRAZAN 100 1X30	TAB11+1
INFINAIR 5 10MG TAB 10X10	BOX9+1
INFINAIR 5+10 110	TAB9+1
JETEX 100 110	TAB9+1
JETEX 200 110	TAB9+1
JETEX SYP 50ML	SYP9+1
LC-OD PLUS TAB 10X10	BOX9+1
MAGNAMYCIN 1G INJ 1X1	VIAL10+1
MAGNAMYCIN 1GM	PCS10+1
MAGNAMYCIN 250 MG VIAL 1X1	VIAL10+1
MAGNAMYCIN 250MG VAIL	PCS10+1
MAGNEX 1.5 FORTE 5ML	INJT10+1
MAGNEX 1GM VIAL 1VIAL	BOX10+1
MAGNEX 1GM.	PCS10+1
MAGNEX-2GM	PCS10+1
NEKSIUM D 20/30 CAP 110	CAP9+1
NEKSIUM D 40/30 1X10	PCS9+1
NEKSIUM D 40/30 CAP 110	CAP9+1
PACTIV 10 MG 100ML	IV5+1
PEPTICAINE LIQUID 30ML	PCS7+3
PITOCIN 1ML INJ 11ML	PCS4+1
PITOCIN AMP 10X1ML	BOX4+1
PITOCIN INJ. 1ML	PCS9+1
SOLU MEDROL 125 1ML	VIL0+1
SULPHA DIMIDINE BOL PHEZ 1X4	Pcs5+1
T M VET TABS 8X4	BOX9+1
TRICOREX SYR 1X100ML	TAB9+1
TRULIMAX 500 3CAP	TAB9+1
TUVACE TAB 110	TAB13+2
VIBAZIME 100 DT 110	TAB9+1
VIBAZIME 100 DT TAB 10X10	BOX9+1
VIBAZIME 200 DT TAB 10X10	BOX9+1
VIBAZIME 200DT 110	TAB9+1
VIBAZIME DUO 325 TAB 10X10	BOX9+1
WARCLAV 625MG TABS 1X6	STRP5+1
WYMOX 250 CAP 115	CAP7+1
WYMOX 30 ML 130ML	SYP9+1
WYMOX 30ML 130ML	PCS9+1
WYMOX 500 CAP 115	CAP7+1
WYMOX 60 ML 160ML	SYP9+1
WYSOLONE DT 5 115	CAP117+3
ABWAL TAB 11	TAB9+1
COLIMEX DF DROP 1X15ML	PHI;19+1
COLIMEX DROP 15ML	19+1
COLIMEX DROPS	PCS19+1
COLIMEX DROPS 1X15ML	PCS19+1
COLIMEX MF TAB 10X10	BOX9+1
COLIMEX TAB 10T	21+4
COLIMEX TABLETS	PCS9+1
COLIMEX TABS 25X10	BOX21+4
DIMOL DROP 10ML	PCS5+1
DIOVOL FORTE SYRUP	PCS9+1
DIOVOL FORTE 400 SYP 1X400ML	PH11+1
DIOVOL FORTE MANGO SYP 1X170ML	PHI;9+1
DIOVOL FORTE MINT SYP 1X170ML	PH9+1
DIOVOL FORTE SYP 1X170ML	PH9+1
DIOVOL LA MINT 200ML	PCS9+1
DIOVOL MINT FLAVOUR SYP 170ML	TAB9+1
DIOVOL MINT TABLETS	PCS9+1
DIOVOL PLUS FORT SYP 170ML	SYPT9+1
DIOVOL TAB 45X12	BOX9+1
EUGI SACHET 1GM	PCS0+9
FLUCOLD AF DROPS 1X15ML	PH9+1
FLUCOLD SYRUP	PCS5+1
FLUCOLD TAB 25X10	BOX21+4
LUBRIJOINT OD 30TAB	PCS10+1
PARAMET 10TAB	STR21+4
PARAMET TABS 25X10	BOX21+4
PERSOL FORTE CREAM 30GM	PCS10+4
WALACORT 20TAB	STR9+1
WALACORT TAB 20X20	BOX9+1
WALACORT TABLETS	PCS9+1
WALYTE POW 22GM 22GM	PCS22+3
WALYTE SACHET 4 2GM 5X4 2GM	BOX9+1
WALYTE SACHETS 25X22GM	BOX22+3
WALYTE SACHTS 4.2GM	PCS9+1
ACE-PROXYVON TAB 1X10	STRP10+1
ACEPROXYVON-XR 10T	TAB5+1
AZIWOK 200MG SYP 15ML 1	SYRU9+1
AZIWOK 250 TAB 3X6	BOX10+1
AZIWOK 500 TAB 10X3	BOX9+1
AZIWOK 500MG TAB 5	TAB11+1
AZIWOK XL 200MG SYP 30ML 1	SYRU11+1
BRO ZEDEX LS 0.5 SYP 1X60ML	SYP14+1
BRO ZEDEX LS 100ML 1X100ML	SYRU14+1
BRO ZEDEX LS KID SYP 60ML 1	SYRU14+1
BRO ZEDEX SF 100ML 1	SYRU14+1
BRO ZEDEX SYP 100ML 1	SYRU14+1
BRO-ZEDEX SF SYP 1X100ML	PH14+1
BUTA PROXYVON GEL 1X30GM	PCS9+1
CEFIWOK O STRIPS TAB 1X10	STRP5+1
CEFIWOK XL 200 TAB 10X10	BOX5+1
GLEEDOX TABS STRIPS 1X10	STRP14+1
NOOTROPIL AMP 4X15	BOX5+1
PROXYVON PLUS CAPS 18X8	BOX17+1
SPASMO PROXYVON AMPOULES 10X2ML	BOX9+1
SPASMO PROXYVON FORTE INJ. 2ML 1	INJ.9+1
SPASMO PROXYVON INJ. 2ML 1	INJ.9+1
TRICEF-XL 200MG TAB 10X10	BOX9+1
VISCODYNE C 100ML	PH9+1
WOKADINE LOTION 1X100ML	PCS5+1
WOKADINE OINTMENT 1X15GM	PCS5+1
ZEDEX P SYP 60ML 1	SYRU11+1
ZEDEX PLUS + SYRUP 60ML 1X60ML	INJ.14+1
ZEDEX PLUS SYP 100ML 1	SYRU14+1
ZEDEX SF SYRUP 100ML 1	SYRU14+1
ZEDEX SYP 100ML 1	SYRU14+1
ACECLO PLUS 600MG 115	TAB+5+1
ACECLO PLUS TAB 1X15TAB	PCS5+1
ACECLO PLUS TABS 10X15	BOX5+1
ACECLO SERA TAB 10T	PCS9+1
ACECLO SERA TABS 10X10	BOX9+1
AEROMONT-B TAB 10TAB	PCS9+1
AEROMONT-B TAB 1X10	STRP9+1
AMBRODIL D SYP 1X100ML	SYP10+3
AMBRODIL Ls DROp 1X15ML	PH5+1
AMBRODIL LS SYP 1X100ML	PH5+1
AMBRODIL LX DROP 15ML	DROP9+1
AMBRODIL LX DROP 15ML	PCS5+1
AMBRODIL LX SYP 100ML	SYP9+1
AMBRODIL LX SYP 100ML	PCS5+1
AMBRODIL PLUS RF 100ML	PCS5+1
AMBRODIL PLUS RF SYP 100ML	SYPT5+1
AMBRODIL PLUS RF SYRUP 1X100ML	PH5+1
AMBRODIL PLUS SYP(L) 100ML	PCS9+1
AMBRODIL S 100ML	PCS9+1
AMBRODIL S SYRUP 1X100ML	PH9+1
AMBRODIL S+SYP 100ML	SYPT9+1
AMBRODIL-D JUNIOR SYP 60ML	PCS5+1
AMBRODIL-D SYP 100ML	PCS5+1
AMBRODIL-D SYP 100ML	SYPS5+1
AMBRODIL-S SYP. 100ML	PCS9+1
ARISTOCILLIN DROP 10ML	PCS4+1
ARISTOMOL 120 MG SYRP 1X60ML	PCS5+1
ARISTOMOL 120 SYP 60ML	PCS5+1
ARISTOMOL 250 MG SYRP 1X60ML	PCS5+1
ARISTOMOL 250 SYP 60ML	PCS5+1
ARISTOMOL 650 10TAB	PCS5+1
ARISTOMOL 650 1X10	PCS5+1
ARISTOMOL M 125 SYP 60ML	PCS9+1
ARISTOMOL M 250 SYP 60ML	PCS9+1
ARISTOZYME FIZZ 14	TAB9+1
ARISTOZYME FIZZ TABS 10X4	BOX9+1
AZENAM 1GM INJ VIAL	PCS9+1
AZENAM 250 VIAL 1X1	VIAL10+3
AZENAM 250MG VAIL 1VAIL	PCS9+1
AZENAM 250MG. VIAL	PCS9+1
AZENAM 2GR 1VAIL	PCS5+1
AZENAM 500 VIAL 1X1	VIAL9+1
AZENAM 500MG INJ VIAL	PCS9+1
AZIVENT 100 SYP 1X15ML	PH10+1
AZIVENT 200 SYP 1X15ML	PHL10+1
AZIVENT 250 TAB 10X10	BOX9+1
AZIVENT 250 TAB 16	PCS9+1
AZIVENT 250TAB 10TAB	9+1
AZIVENT 500 TAB 10X5	BOX9+1
AZIVENT 500 TAB 1X5	PCS9+1
AZIVENT 500MG TAB 5TAB	PCS9+1
AZIVENT SYP 100MG 15ML	PCS10+1
AZIVENT SYP 100MG 15ML	PCS10+1
AZIVENT SYP 200MG 15ML	PCS10+1
AZIVENT SYP 200MG 15ML	PCS10+1
AZIVENT XL 100 30ML	PCS9+1
AZIVENT XL 100MG 30ML	PH9+1
AZIVENT XL 200 30ML	PCS9+1
AZIVENT XL 200MG 30ML	PH9+1
AZIVENT XL100 SYP 30ML	SYPC9+1
AZIVENT XL200 SYP 30ML	SYPC9+1
BACIGYL SYP. 30ML 30ML	PCS21+4
BACIROM 1GM VIAL	PCS10+4
BACIROM 250MG VIAL	PCS9+1
BILAMONT TAB 10TAB	PCS9+1
BILAMONT TAB 1X10	PCS9+1
BIOGERMINA OS 2BILLION SPORES 6AMP	PCS5+1
BIOGERMINA OS RESP 6X5ML	BOX5+1
CEFADROX CV TAB 10X10	BOX9+1
CHEXID 40 CAP 1X10	STRP9+1
CHEXID 40 RF 10TAB	PCS9+1
CHEXID D CAP 1X10	PCS9+1
CHEXID D TAB 1X10	STRP9+1
CHEXID RF TAB 1X10	PCS9+1
CHEXID-D 10TAB	PCS9+1
CLINGEN WASH 100ML	WASH9+1
CLINGEN WASH 1X100ML	PHY9+1
COMBITHER 120 TAB 1X8	PCS5+1
COMBITHER 15ML SYP 1X15ML	PH9+1
COMBITHER 30ML 30ML	SYP9+1
COMBITHER 30ML SYP 1X30ML	PH9+1
COMBITHER FORTE 16	PCS5+1
COMBITHER FORTE TAB 1X6T	PCS5+1
COMBITHER FORTE TABS 10X6	BOX5+1
COMBITHER SYP 15ML	PCS9+1
COMBITHER SYP 30ML	PCS9+1
COMBITHER-AT INJ 5ML	VIL10+22
CRITIPRO 200GM	PCS11+1
CRITIPRO DM POW 180GM	PCS11+1
CRITIPRO DM POWDER 180GM	GRA11+1
CRITIPRO DM POWDER 180GM 1X180GM	PH11+1
CRITIPRO POEDWE 200GM	POWD11+1
CRITIPRO POWDER 1X200GM	PH11+1
DAROLAC MINI 6AMP	PCS11+1
DAROLAC MINI 6X5ML	PCS11+1
DAROLAC MINI RESP 6X5ML	STRP5+1
DAROLAC SYP 1X30ML	PH9+1
DAROLAC SYP 30ML	PCS9+1
DAROLAC SYRUP 1X30ML	SYR9+1
DORIPEN 500 5ML	VIL4+1
DUOTAX 1 5MG INJ VIAL	PHL10+1
DUOTAX INJ 1500MG 1VIAL	10+1
DUOTAX-1.5GM VIAL	PCS10+1
DURATAZ 1 125MG 1VIAL	Pcs5+1
DURATAZ 1.125 GM 5ML	VIL5+1
DURATAZ 2.25GM VIAL	PCS10+1
DURATAZ 4 5MG INJ VIAL	VIAL10+12
DURATAZ 4.5GM VIAL	VIAL10+8
DURATAZ INJ 1 125GM 1VIAL	5+1
DURATAZ INJ 2 25 GM 1VAIL	PCS5+1
DURATAZ INJ 4 5 GM 1VIAL	10+10
DYDROJOY 10 TAB 1X10	PCS5+1
DYDROJOY 10MG 10TAB	PCS5+1
DYDROJOY 10MG TAB 1X10	STRP10+3
ENOXAFLO 40MG 0 4ML	PCS10+13
ENOXAFLO 60MG 0 6ML	PCS1+2
ENOXAFLO 80MG 0 8ML	PCS5+9
ETOCOX 60MG TAB 10X10	BOX5+1
ETOCOX 90MG 1X10TAB	PCS5+1
FILGUD-10MG 2X2	PCS4+10
FLEXON TABS 10X15	BOX9+1
FLEXON 15TAB	PCS24+1
FLEXON 650 15TAB	PCS5+1
FLEXON CREM 15GM	TAB9+1
FLEXON PLUS 15TAB	5+1
FLEXON SYP 100ML	PCS9+1
FLEXON SYP 60ML	PCS9+1
FLEXON SYP 60ML	PCS9+1
FLEXON SYP. 100ML	PCS9+1
FLEXON SYRUP 1X100ML	PHL9+1
FLEXON SYRUPS 90X60ML	CASE9+1
FLEXON TAB 50X15	BOX24+1
FLEXON TAB 1X15TAB	PCS24+1
FOLINEXT D CAP 10X15	BOX9+1
FOLINEXT GOLD TAB 10X10	BOX9+1
FOLINEXT TAB 10X30	BOX10+1
FOLINEXT TAB 130	TAB9+1
FOLINEXT TAB 30TAB	PCS9+1
FOLINEXT-D 15CAP	PCS9+1
FOLINEXT-D100 115	TAB9+1
FONDUM INJ 2 5MG 1VAIL	PCS2+1
FORCEF 1 5GM VAIL 1VAIL	PCS10+4
FORCEF 125 1X4	PCS9+1
FORCEF 125MG 1X10TAB	PCS9+1
FORCEF 250 110	TAB9+1
FORCEF 250 TAB 10X10	BOX9+1
FORCEF 250 VAIL 1VAIL	PCS10+4
FORCEF 250 VIAL 1X1	VIAL5+1
FORCEF 250MG 1X10	PCS9+1
FORCEF 250MG TAB 1X10TAB	PCS9+1
FORCEF 500 110	TAB9+1
FORCEF 500 TAB 10X10	BOX10+3
FORCEF 500MG 1X10TAB	PCS9+1
FORCEF 500MG 1X4	PCS9+1
FORCEF 750 VIAL 1X1	VIAL5+1
FORCEF 750MG VAIL 1VAIL	PCS10+4
FORCEF CV 250 16	PCS4+1
FORCEF CV 250 TAB 10X6	BOX4+1
FORCEF CV 250MG 6TAB	PCS4+1
FORCEF CV 500MG 6TAB	PCS4+1
FORCEF-1500MG. VIAL	PCS5+1
FORCEF-250MG VIAL	PCS5+1
FORCEF-750MG. VIAL	PCS5+1
FOSFOCIN SCH 8GMS	PCS9+1
GIFAXIN 200 1X10	PCS5+1
GIFAXIN 200MG 10TAB	PCS5+1
GIFAXIN 400 TAB 10X10	BOX5+1
GIFAXIN 400MG 10TAB	PCS5+1
GIFAXIN 550MG TABS 10X10	BOX5+1
GIFAXIN SYP 100MG 1X60ML	PH10+1
GIFAXIN SYP 60ML	PCS10+1
GRANDEM INJ 5AMP	PCS5+1
GRANDEM MD TAB 10X10	BOX9+1
GRANDEM MD TABS 10S 10TAB	PCS9+1
GRANDEM SYP 10ML	9+1
GRANDEM SYP 10ML	PCS9+1
GRANDEM SYRUPS 1X10ML	PH.9+1
HATRIC 2 DROP 15ML	PCS9+1
HATRIC 2 SYP 60ML	PCS9+1
HATRIC 3 DROP 1X15ML	PHL.9+1
HATRIC-3 DROPS 15ML	DROP9+1
HATRIC-3 TAB 10TAB	PCS9+1
HATRIC-3 TAB 1X10	PCS9+1
IMAX FORT 1X10	STP10+1
IMAX FORTE CAP 10X10	BOX10+1
IMAX S INJ 1X5ML	AMP10+25
IMAX XT DROP 150ML	SYP5+1
IMAX XT DROP 15ML	PCS9+1
IMAX XT SUSP 1X150ML	PCS5+1
IMAX XT SYP 150ML	PCS5+1
IMAX XT TAB 10X10	BOX5+1
IMAX XT TAB 10TAB	PCS5+1
IMAX XT TAB 110	TAB5+1
IMAX-S AMP 5ML	PCS10+25
IMAX-S INJ 5ML	TAB1+1
IMMUGARD 200MG CAPS 15CAPS	PCS9+1
IMMUGARD C TAB 10TA	PCS9+1
IMMUGARD-C CAP 1X10	PCS9+1
ITRAFIX 100 8CAP	PCS10+3
ITRAFIX 100 CAP 10X8	BOX10+3
ITRAFIX 100CAP 1X4	TABS9+1
ITRAFIX 200 8CAP	PCS10+4
ITRAFIX 200 CAP 10X8	BOX10+3
ITRAFIX 200CAP 1X4	TABS5+1
LETPRO 2 5MG 5TAB	PCS7+3
LULIDERM 20GM CREAM 1X20GM	TUBE5+2
LULIDERM CREAM 10GM 1X10GM	TUBE10+4
LULIDERM CREAM 10GMS	10+4
LULIDERM CREAM 1X10GR	CRE5+1
LULIDERM CREAM 20GMS 20GMS	PCS5+1
LULIDERM CREM 20GM	PCS5+1
LULIDERM LOTION 1X30ML	PHL5+1
LULIDERM LOTION 30ML	PCS5+1
MAGNA SB 1 5GM INJ 1VAIL	PCS1+2
MAGNA SB 1GM 10ML	PCS10+13
MAXICEF -OF 110	10PC4+1
MAXICEF 1GM INJ VIAL	BOX10+3
MAXICEF 250MG INJ VIAL	VIAL10+3
MAXICEF 500 INJ 1X1	VIAL10+3
MAXICEF INJ 250MG 1VIAL	PCS10+3
MAXICEF O 100 SYP 1X30ML	PCS5+1
MAXICEF O 100 SYP 30ML	PCS5+1
MAXICEF O 200 1X10	PCS10+4
MAXICEF O 200 MG 10TAB	PCS10+3
MAXICEF O 50 SYP 30ML	9+1
MAXICEF OF TAB 10TAB	PCS4+1
MAXICEF-250MG VIAL	VIAL10+3
MAXICEF-500MG	PCS10+3
MEGA CV 1 20GM INJ VIAL	VIAL10+4
MEGA CV 1 2GM VAIL 1VAIL	PCS10+5
MEGA CV 1.2GR 1X1.2GR	PCS10+5
MEGA CV 150MG 1VAIL	PCS10+5
MEGA CV 150MG 1X150GR	PCS10+3
MEGA CV 150MG INJ VIAL	BOX10+4
MEGA CV 300GR 1X300GR	PCS10+3
MEGA CV 300MG 1VAIL	PCS10+5
MEGA CV 300MG INJ VIAL	VIAL10+3
MEGA CV 30ML SYP 1X30ML	PH5+1
MEGA CV 375MG 6TAB	PCS10+1
MEGA CV 375MG TABS 10X6	BOX10+1
MEGA CV 600 5ML	VIL25+8
MEGA CV 600MG VIAL 1VIAL	VIAL10+3
MEGA CV 60ML SYP 60ML	PH5+1
MEGA CV 625 1X10TAB	PCS5+1
MEGA CV 625 TABS 10X10	BOX4+1
MEGA CV 625MG 10TAB	PCS5+1
MEGA CV D/SYP 60ML	SYP5+1
MEGA CV DOU 1GM TAB 1X6	STRP10+1
MEGA CV DROP 10ML	PCS5+1
MEGA CV DROP 10ML	PCS5+1
MEGA CV DROPS 1X10ML	PH5+1
MEGA CV DRY SYR 1X30ML	PCS5+1
MEGA CV DT TABS 10X6	BOX5+1
MEGA CV DUO 1 GR 1X6TAB	PCS10+1
MEGA CV DUO 1GM 6TAB	PCS10+1
MEGA CV FORTE DRY SYP 1X30ML	PH5+1
MEGA CV FORTE SYP 30ML	PCS5+1
MEGA CV FORTE SYP 30ML	SYP10+1
MEGA CV FORTE SYRP 1X60ML	PCS5+1
MEGA CV FORTE TAB 6S	TAB10+1
MEGA CV KID DT 20 1X6TAB	PCS5+1
MEGA CV KID DT 6TAB	PCS5+1
MEGA CV SUP 1X30ML	PCS5+1
MEGA FLEXON TAB	TAB5+1
MEGA FLEXON TAB 12X10	BOX5+1
MEGACHOLIN PLUS 10TAB	PCS5+1
MEGACHOLIN PLUS 1X10	PCS5+1
MEGACHOLIN PLUS TABS 1X10	STRP5+1
MEGACHOLIN RF 2ML 2ML	PCS10+4
MEGACHOLIN RF 2ML INJ 5AMP	PCS2+1
MEGACHOLIN RF 4ML 4ML	PCS2+1
MEGACHOLIN RF 4ML INJ 5AMP	PCS2+1
MEGACHOLIN RF TAB 10TAB	PCS5+1
MEGACHOLIN RF TAB 1X10	PCS5+1
MEGACHOLIN RF TAB 1X10	VIAL5+1
MEGACHOLIN SYP 60ML	PCS5+1
MEGAFLEXON TAB 10TAB	PCS5+1
MEGAHEAL GEL 15GM 1X15GM	PCS9+1
MEGAHEAL GEL 15GMS	9+1
MEGAHEAL GEL 50GM 1X50GM	PCS9+1
MEGAHEAL GEL(S) 15GM	GEL9+1
MEGAHEAL SPRAY 1X60ML	PCS9+1
MEGAHEAL SPRAY 60ML	SPAR9+1
MEGAHEAL SPRAY 60ML	PCS9+1
MEGANEURON AMP 1AMP	9+1
MEGANEURON AMP 1X1ML	AMP9+1
MEGANEURON FORTE INJ 5X2ML	BOX5+2
MEGANEURON FORTE INJ 1AMP	10+4
MEGAPEN 1GM VAIL 1VIAL	21+4
MEGAPEN 1GM VAIL VAIL	PCS22+3
MEGAPEN 1GM VIALS CC VIALS	PCS168+32
MEGAPEN 250 VIAL 1VIAL	43+7
MEGAPEN 250MG VAIL VAIL	PCS86+14
MEGAPEN 250MG VIALS CC VIALS	PCS43+7
MEGAPEN 500 CAPS 110	PCS9+1
MEGAPEN 500MG CAP 1X10	STP19+1
MEGAPEN 500MG CAPS 10X10	BOX9+1
MEGAPEN 500MG VAIL VAIL	PCS9+1
MEGAPEN 500MG VIAL 1VIAL	43+7
MEGAPEN 500MG VIALS CC VIALS	PCS400+65
MEGAPEN CAP 1X10CAP	9+1
MEGAPEN XP CAP 110	STP17+3
MEGAPEN XP CAP 1X10CAP	10+1
MEGAPEN XP CAPS 10X10	BOX85+15
MEGAZOLID 100 DRY SYP 1X30ML	PH9+1
MEGAZOLID 100 SYP 30ML	9+1
MEGAZOLID 100SYP 30ML	SYP9+1
MEGAZOLID 600 TAB 10X10	BOX9+1
MEGAZOLID 600 TAB 1X10S	PCS9+1
MEGAZOLID IV 1X300ML	PH1+3
MEGAZOLID IV 300ML	PCS1+3
MEGAZOLID PLUS TAB 1X10S	PCS9+1
MERO 125 INJ 1VAIL	PCS10+6
MERO 125 INJ 1X1	VIAL10+12
MERO 125 INJ 5ML	INJC10+6
MERO 1GM 5ML	VIL10+10
MERO 1GM VIAL 1 VIAL	PHL1+3
MERO 250 5ML	VIL10+6
MERO 250 VAIL 1VAIL	1+1
MERO 250MG VIAL 1 VIAL	VIAL5+6
MERO 500 VIL 5ML	VIL10+6
MERO 500MG 1VAIL	PCS10+6
MERO 500MG VIAL 1 VIAL	VIAL10+12
MERO O 200 1X6	STRI9+1
MERO O 200 TAB 1X10	STRP9+1
MERO O 200MG 6TAB	PCS9+1
MERO O ER 300 1X6	STRI5+1
MERO O ER 300MG 10TAB	PCS5+1
MERO SB 1 5 1VAIL	10+5
MERO SB 1 5GM VIAL 1 VIAL	VIAL1+1
MERO SB 1.5 10ML	VIL10+4
MERO-O ER 300 TAB 1X6	STRP5+1
MEROBAX 125 5ML	PCS18+12
MEROBAX 125 VAIL 1VAIL	PCS12+8
MEROBAX 1GM 5ML	PCS12+8
MEROBAX 1GM VAIL 1VAIL	PCS12+11
MEROBAX 1GM VIAL 1 VIAL	VIAL12+9
MEROBAX 250 5ML	PCS12+8
MEROBAX 500 3ML	PCS12+8
MEROBAX SB 1 5GM VAIL 1X1	BOX2+1
MIFTY 200MG TAB 1X1	PCS10+9
MIFTY KIT 20X1 TAB 1X1KIT	STRP1+4
MIFTY KIT 1KIT	TAB1+5
MIFTY KIT 1KIT	PCS1+5
MIKACIN 100 VIAL 1X2ML	VIAL10+8
MIKACIN 1000MG 5ML	PCS5+1
MIKACIN 100MG VAIL 2ML	PCS10+8
MIKACIN 250 VIAL 1X2ML	VIAL1+1
MIKACIN 250MG VAIL 2ML	PCS1+1
MIKACIN 500 VAIL 1X2ML	VIAL10+12
MIKACIN 500MG VAIL 2ML	PCS10+12
MIKACIN 750MG 5ML	PCS5+1
MIKACIN INJ 100MG 1VIAL	PCS22+18
MIKACIN INJ 1GMS 1VAIL	PCS10+3
MIKACIN INJ 250MG 1VIAL	PCS10+10
MIKACIN INJ 500MG 1VIAL	PCS10+12
MIKACIN INJ 750MG 1VAIL	PCS5+1
MONOCEF 125MG VAIL VAIL	PCS5+1
MONOCEF 125MG VIAL 1 VIAL	PCS5+1
MONOCEF 1GM VAIL 1X1VIAL	PCS1+1
MONOCEF 1GM VAIL VAIL	PCS1+1
MONOCEF 250MG VAIL VAIL	PCS10+6
MONOCEF 250MG VIAL 1 VIAL	PCS2+1
MONOCEF 2GM VIAL 1VIAL	VIAL10+3
MONOCEF 2GM VIAL VIAL	PCS10+4
MONOCEF 500MG VAIL VAIL	PCS10+4
MONOCEF 500MG VIAL CC VIAL	PCS10+4
MONOCEF INJ 125MG 1VIAL	5+1
MONOCEF INJ 1GM 1VIAL	10+10
MONOCEF INJ 250MG 1VIAL	10+5
MONOCEF INJ 2GM 1VAIL	PCS10+4
MONOCEF INJ 500MG 1VIAL	PCS10+4
MONOCEF O 100 SUSP 1X30ML	PH9+1
MONOCEF O 200MG TAB 1X10T	PCS5+1
MONOCEF O 50MG DRY SUSP 1X30ML	PH9+1
MONOCEF O CV 100 SYP 1X30ML	PH9+1
MONOCEF O CV 200MG TABS 10X10	BOX9+1
MONOCEF O CV 50 SYP 1X30ML	PH9+1
MONOCEF O D S 100MG 1X30ML	9+1
MONOCEF O D S 50MG 1X30ML	PCS9+1
MONOCEF O DROP 10ML	PCS5+1
MONOCEF O DROP 1X10ML	PCS5+1
MONOCEF O DROPS 10ML	PCS5+1
MONOCEF SB 1GM 1VIAL	PCS10+16
MONOCEF SB 1GM 5ML	INJ10+16
MONOCEF SB 1GM VIAL 1VIAL	VIAL10+16
MONOCEF SB 250 VIAL 1VIAL	VIAL1+1
MONOCEF SB 250MG 1VIAL	1+1
MONOCEF SB 500 1VAIL	10+7
MONOCEF SB 500 1XVAIL	VAIL10+7
MONOCEF SB 500 VIAL 1X1	VIAL221+154
MONOCEF-O 200 1X10	PCS5+1
MONOCEF-O 200MG TABS 10X10	BOX5+1
MONOCEF-O CV 100 D S 30ML	PCS9+1
MONOCEF-O CV 100SYP 30ML	SYP9+1
MONOCEF-O CV 200 1X10	STR9+1
MONOCEF-O CV 200TAB 1X6TAB	9+1
MONOCEF-O CV 50 SYRUP 1X30ML	PCS9+1
MONOCEF-O CV 50MG D S 30ML	PCS9+1
MONOCEF-O SYP 100MG 30ML	PCS9+1
MONOCEF-O SYP 50MG 30ML	PCS9+1
MONTAZ 125 1VAIL	PCS10+3
MONTAZ 125MG INJ CC VIALS	VIAL10+3
MONTAZ 1G VIAL 1X1	VIAL10+12
MONTAZ 1GM 1VAIL	PCS10+12
MONTAZ 250 1VAIL	PCS10+11
MONTAZ 250MG VIAL	VIAL10+11
MONTAZ 250MG VIAL 1 VIAL	PCS10+11
MONTAZ 500 1VAIL	PCS10+7
MONTAZ 500MG VIAL 1X1	VIAL10+7
MONTAZ INJ.125MG VIAL	STP10+3
MONTAZ-1GM VIAL	VIAL10+10
MONTAZ-500MG VIAL	VIAL10+7
MONTINA FX TAB 10X10	BOX9+1
MONTINA FX TAB 1X10	PCS9+1
MONTINA L DT 1X10	TAB9+1
MONTINA L DT TAB 10X10	BOX9+1
MONTINA L SYP 1X30ML	PH9+1
MONTINA L SYP 1X60ML	PH9+1
MONTINA L SYP 30ML	SYP9+1
MONTINA L TAB 10X10	BOX9+1
MONTINA L TAB 110	TAB9+1
MONTINA L-SYP 60ML	SYP9+1
MONTINA-FX 10TAB	PCS9+1
MONTINA-L DT 10TAB	9+1
MONTINA-L SYP 30ML	9+1
MONTINA-L TAB 10TAB	PCS9+1
MUCIFLO TAB 10X10	BOXP9+1
MUCIFLO TAB 10TAB	PCS9+1
MUCIFLO TABLETS 1X10	PCS9+1
NEW HATRIC-3 TAB 10X10	BOX9+1
O-LYTE SYP 200ML	SYP4+1
OFLER 200 10TAB	PCS10+6
OFLER 200 1X10	PCS10+4
OFLER 200MG TABS 10X10	BOX10+4
OFLER 400 1X10	PCS10+4
OFLER 400MG TABS 10X10	BOX10+4
OFLER OZ TAB 10X10	BOX4+1
OFLER OZ TAB 110	TAB4+1
OFLER-TZ TAB 10X10	PCS10+1
OMCEF 100 DT 10TAB	PCS5+1
OMCEF 100 DT 110	TAB5+1
OMCEF 100 DT TABS 10X10	BOX5+1
OMCEF 200 110	TAB4+1
OMCEF 200MG 10TAB	PCS4+1
OMCEF 200MG
ACILOC ONLY SYP 1X100ML	PH10+1
ACILOC RD TAB 24X15	BOX10+1
ACILOC-RD 20 TABS. 1X20	PCS10+1
ARTE PLUS CD 16	TAB9+1
BELAMYL 10ML INJECTION 1X10ML	PCS29+1
BELAMYL 30ML INJECTION VET 1X30ML	Pcs15+1
BELAMYL 50ML 1VAIL	Pcs24+1
BOVIRUM BOLUS 254 VET 1X25	STP5+1
CIPROBID 250MG TAB 1X10	PCS9+1
CIPROBID 500 1X10	PCS9+1
CIPROBID 500MG TABS 30X10	BOX9+1
CIPROBID I.V. 1X100M	10+2
CIPROBID-500MG TABS. 3010	BOX11+4
CODINE SULPHATE TAB 25X10	BOX23+2
COOT 15GM ONT 1X15GM	TUB5+1
DECANEURABOL 50 AMP 1X1ML	AMP9+1
DEXONA TABS. 1X10	15+1
DOMPERON-10 MELTABS. 1X10	20+2
ESPRA-40 1X10	PCS5+1
ETOGESIC ER TAB 110	PCS9+1
ETOGESIC MR 110	TAB9+1
GLOBAC Z CAP 1X30	PCS11+1
GLOBAC Z LIQ 200ML	PCS4+1
GRD POWDER CHOC 200GM	PCS11+1
HAEM UP SYRUPS 1 PH	PCS5+1
HEXANIDE 90ML VET 1X90ML	Pcs2+1
HEXANIDE BOLUS STRIPS VET 1X4	Pcs2+1
INDITEL 80 TAB 1X15	STRP9+1
INDITEL AM TAB 1X15	STRP9+1
INDITEL H40 TAB 10X10	BOX9+1
LEVOCIDE 500 TABS 20X5	BOX5+1
LEVOCIDE-500MG TABS. 1X5	5+1
LEVODAY 500 1X10	STP9+1
LINID I/V 300ML	PCS5+1
LIVAFIN CREAM 30GM 130GM	PCS5+1
LMX 250MG CAPS 20X10	BOX5+1
LMX 500MG CAPS 30X6	BOX10+1
LMX FORTE 625 TABS 10X10	BOX10+1
LMX-1.2GM INJ. 1VAIL	PCS10+5
LMX-500MG CAPS. 306	BOX5+1
LMX-FORTE-625MG TAB 510	BOX5+1
MIFIGEST KIT 1KIT	KIT1+5
MILKMIN 1KG 1XKG	Pcs5+1
MYCOBUTOL 1000MG TABS 10X10	PCS5+1
MYCOBUTOL-1000MG TABS. 1X10	6+1
MYCOBUTOL-400MG TABS. 1X10	6+1
MYCOBUTOL-800MG TABS. 1X10	PCS10+1
NEUROTRAT AMP. AMP	PCS11+1
NEUROTRAT CAP 1X10	PCS10+1
NEUROXIN-10ML INJECTION VET 110ML	Pcs11+1
NIFNEXT 100SR 1X10	CAP10+1
NUCOXIA 120 TAB 1X10	STRP0+1
NUCOXIA 90 TAB 1X15	STRP205+20
NUCOXIA D3 CAP 1X10	STRP9+1
NUCOXIA MR TAB 1X10	PCS11+1
NUCOXIA MR TAB 1X10	STRP11+1
NUCOXIA P TAB 1X15	STRP9+1
NUCOXIA PG TAB 1X10	STRP9+1
NUCOXIA SP TAB 1X10	STRP9+1
NUCOXIA-120MG 1X10	PCS9+1
NUROZ OD TAB 10X10	PCS10+1
OCID IV 40MG VIL 1X1	PH5+1
OCID QRS 20 1X15	PCS9+1
OCID-20 1X20	PCS9+1
OCID-D 1X10	PCS9+1
OFLIN IV 100ML	PCS2+1
OFLIN-200MG TABS. 1X10	4+1
ORNI-500MG TABS. 1X10	9+1
OXALGIN DP TABS 1X15	STRP10+4
OXALGIN GEL 30GM	10+1
OXALGIN NANO GEL 1X30GM	TUBE5+1
OXALGIN-DP TABS. 1X10	PCS4+1
P-ZIDE 500MG TABS 20X10	BOX5+1
P-ZIDE-1000MG TABS. 1X10	6+1
P-ZIDE-500MG TABS. 1X10	PCS10+1
P-ZIDE-750MG TABS. 1X10	6+1
R-LOC 150 1X30	PCS9+1
R-LOC 150MG TABS. 1X30	5+1
SIQUIL 5ML 1VAIL	Pcs19+1
STAYTAL 30 14	TAB10+1
STECLIN BOLUS 25X4	Pcs5+1
SUGAR FREE 110 S TABS 1X100	PCS24+1
SUGAR FREE GOLD (B).TABS. 330TAB	24+1
SUGAR FREE GOLD 300 TABS 1X300	PCS24+1
SULPHA BOLUS STRIP 1X2	BOX21+4
SULPHA BOLUS STRIP 510 VET 5X10	STP5+1
SUPPLIVITE -M 250G 250GM	Pcs201+39
SUSTANON 100 AMP 2ML	AMP9+1
SYMBIOTIK TABS 20X6	PCS5+1
THROMBOPHOB OINT 20GM.	PCS7+1
THROMBOPHOB-GEL 20GM	GEL9+1
TINIBA I/V 400ML	PCS5+1
TINIBA INFUSION. 1X400M	8+1
TRAMAZAC P TAB 1X10	STP9+1
TRAMAZAC PD 1X10	STP9+1
TRICORT 40MG VIALS 1X1ML	INJ10+1
TRIGAN D TABS 20X10	BOX5+1
TRIGAN-D TABS. 1X1020	BOX9+1
VETCLOX FORTE 2GM VIAL VET 1VAIL	Pcs83+17
ZOBID M 100ML VET 1 VAIL	Pcs7+1
ZOLDAC 0.25 110	TAB10+4
ZYROF 25 1X10	PCS1+1
ZYROF MELTAB 1X10	PCS1+1
ADVENT FORTE SYP 30ML	PCS4+1
ADVENT SYP 228 5mg 30ML	PCS9+1
ALERGIN TAB N/F 10	GEN.9+1
ALERGIN-L TAB 10	GEN.9+1
ALERID TAB 10TAB	PCS9+1
ASTHALIN DX SYP 100ML	PCS9+1
ASTHALIN RESPULES. 1X2.5M	9+1
AZEE XL 200 SYP 30ML	PCS9+1
AZIMAX 100 R U 10ML	PCS9+1
AZIMAX 200 R U 10ML	PCS9+1
AZIMAX-500MG TABS. 1X3	4+1
BENDEX SUSP. 1X10ML	9+1
BENDEX TABLET 1X1	20+4
BENDEX-400TAB 1	GEN.9+1
BUDECORT-0.5MG RESPULES. 20X2ML	4+1
BUDECORT-RESP.1MG 1X2ML	4+1
CEFADUR-125DT TABS. 1X10	9+1
CEFADUR-250DT TABS. 1X10	9+1
CEFADUR-500MG TABS. 1X10	9+1
CEFBACT 1GM VAIL 1VAIL	PCS19+21
CEFIX-100 TAB 10	GEN.4+1
CEFIX-200 TAB 10	GEN.4+1
CEFIX-DS SYP 1	GEN.9+1
CEFOPROX 200 MG TAB 10T	4+1
CEFRAX 200 TAB 10	GEN.4+1
CEPHADEX-125 TAB 10	GEN.4+1
CEPHADEX-500 CAP 10	GEN.4+1
CIPLADIN 15GM(M) OINT 1	GEN.9+1
CIPLADIN 20GM OINT 1	GEN.9+1
CIPLADIN 25GM OINT 1	GEN.9+1
CIPLOX 500MG 10T	PCS11+1
CIPLOX D EYE DROP 10ML	PCS19+1
CIPLOX E E DROP 10ML	PCS10+1
CIPLOX TZ 10T	PCS5+1
CIPLOX-500MG TABS. 1X10	2+1
CIPLOX-TZ TABS. 1X10	PCS4+1
CIPMOX 250(115)CAP 15	GEN.9+1
CIPMOX CV-625 110 1	GEN.4+1
CIPMOX-500 CAP{PILLA} 15	GEN.0+1
CIPMOX-500(LAAL) CAP 15	GEN.9+1
CLEARNOZ 0.05% PEAD.DROPS 1X10ML	9+1
CLEARNOZ 0.1% NASAL DROPS 1X10ML	9+1
CLOCIP-100M PWD 10	GEN.23+5
CLOCIP-75GM PWD 1	GEN.173+19
CPINK-FCM 500MG INJ 10ML	PCS4+1
DUOLIN LD RESP 2 5ML	PCS37+3
DUOLIN RESP 3ML 3ML	PCS37+3
DUOLIN RESPULES 2 5ML	PCS37+3
DUOLIN RESPULES. 5X2.5M	4+1
DYTOR INJECTION. 5X1X2M	9+1
EMESET AMP 2ML	PCS1+1
FERTOMID 50MG 10T	PCS9+1
FEVAGO SYRUP. 1X60ML	9+1
FLUKA-150 TAB 1	GEN.13+7
FORCAN-150MG TABS. 1X1	4+1
FOURDERM 20GM OIT 1	GEN.141+16
FOURDERM PLUS CREAM 15GM 1	GEN.4+1
FOURDERM-10GM ONMT 1	GEN.100+11
FOURDERM-5GM ONMT 1	GEN.9+1
GATIQUIN-200MG TABS. 1X5	9+1
GATIQUIN-400MG TABS. 1X5	9+1
IBUGESIC NANO GEL 30GMS	PCS9+1
IBUGESIC PLUS 15T	PCS14+1
IBUGESIC PLUS SYP 100ML	PCS9+1
IBUGESIC-PLUS SYP. 1X60ML	9+1
IBUGESIC-PLUS TABS. 1X15	19+1
LANZOL-30MG CAPS. 1X10	7+3
LEVOFLOX 500 TAB 10T	PCS4+1
LEVOFLOX I.V. 1X100M	3+3
LEVOFLOX-500MG TABS. 1X10	9+1
LEVOQUIN-250 TAB 5	GEN.4+1
LEVOQUIN-500 TAB 5	GEN.4+1
LUMET 80 6TAB	PCS7+3
LYCOGARD 225ML SYP 1	GEN.77+19
MEBEX TAB 10	GEN.9+1
MEGACLOX CAP 10	GEN.4+1
MEGACLOX-DT TAB 10	GEN.4+1
MISOPROST-100MG TABS. 1X4	9+1
MISOPROST-200 4T	PCS9+1
MISOPROST-200MG TABS. 1X4	9+1
MOBICAM-DT TAB 10	GEN.9+1
MONTAIR LC KID 10T	PCS9+1
MONTAIR-LC TABS. 1X10	5+1
MT-PILL TABS. 1X1	1+3
NADIBACT PLUS 7 5GM	PCS9+1
NEW POWERGYL 30ML SYP 1	GEN.9+1
NICIP PLUS TAB(JAR) 10	GEN.9+1
NICIP-100 TAB 10	GEN.9+1
NICISPAS TAB 10	GEN.9+1
NICOTAX-2 MINT PLUS 9TAB	PCS17+1
NICOTAX-2 PAAN 9TAB	PCS17+1
NICOTAX-4 MINT PLUS 9TAB	PCS17+1
NICOTAX-4 PAAN 9TAB	PCS17+1
NICOTEX GUM FRUITY MINT 9TAB	PCS17+1
NICOTEX-2 25TAB	PCS17+1
NICOTEX-4 25TAB	PCS17+1
NO DARAR CREAM 25GM 1	GEN.4+1
NODARD TAB 15	GEN.9+1
NORFLOX 400MG 10T	PCS5+1
NORFLOX TZ 10T	PCS5+1
NORFLOX-100DT TABS. 1X10	4+1
NORFLOX-200MG TABS. 1X10	4+1
NORFLOX-400MG TABS. 1X10	4+1
NORFLOX-TZ TABS. 1X10	4+1
NOVACLAV-625 16 CAP 16	GEN.4+1
NOVACLOX-500MG CAPS. 1X9	4+1
NOVACLOX-LB 500MG CAPS. 1X15	4+1
NOVACLOX-LB CAP 10	GEN.4+1
NOVAMOX CV 625 10CAP	PCS5+1
NOVAMOX CV SYP 30ML	PCS5+1
NOVAMOX DROP 10ML	PCS9+1
NOVAMOX DROPS. 1X10ML	7+3
NOVAMOX DRY SYP 30ML	PCS9+1
NOVAMOX R U 125 30ML	PCS9+1
NOVAMOX R U 125 60ML	PCS9+1
NOVAMOX SYP.(L). 1X60ML	4+1
NOVAMOX SYP.(S). 1X30ML	4+1
NOVAMOX-250DT TABS. 1X15	6+4
NOVAMOX-250MG CAPS. 1X15	4+1
NOVAMOX-500MG CAPS. 1X10	PCS2+1
NOVAMOX-LB 500 CAPS. 1X6	7+3
NUTROLIN-B (+) CAPS. 1X10	9+1
NUTROLIN-B PLUS 15CAP	PCS9+1
NUTROLIN-B SYP 60ML	PCS9+1
NUTROLIN-B SYRUP. 1X60ML	9+1
OFLOX-200MG TABS 1X10	4+1
OFLOX-400MG TABS. 1X10	4+1
OFLOX-OZ TABS. 1X10	4+1
OLOX 200MG TAB 10	GEN.4+1
OLOX-OZ TAB 10	GEN.4+1
OMNIGEL 10GM ONMT 1	GEN.4+1
OMNIGEL 20GM(M) OINT 1	GEN.17+3
OMNIGEL 30GM (L) OINT 1	GEN.4+1
OMNIGEL 75GM ONMT 1	GEN.4+1
OMNIGEL SPRAY(L)55GM 1	GEN.65+7
OMNIGEL SPRAY(M)35GM 1	GEN.388+43
OMNIGEL SPRAY(S)20GM 1	GEN.77+19
OMNIX 100 SYP 30ML	PCS4+1
OMNIX 200MG 10TAB	PCS5+1
OMNIX 50 DRY SYP 50ML	PCS4+1
OMNIX 50DT 10TAB	PCS4+1
OMNIX-O TAB 10TAB	PCS4+1
ORS LEMON-200ML LIQUID 1	GEN.9+1
ORS PROLYTE APPLE LIQD CIPLA 200ML	GEN.9+1
ORS PROLYTE ORANGE LIQUID CIPL 200ML	GEN.9+1
ORS PROLYTE PWD 1GM(L)CIPLA 1	GEN.9+1
PANSEC I V 1VAIL	PCS1+1
PANTIX DSR CAP 10	GEN.4+1
PANTOSEC D TABS 10	GEN.9+1
PANTOSEC-DSR CAP 10	GEN.9+1
PARACIP 500 TAB 110 10	GEN.9+1
RABESEC-DSR CAP 10	GEN.4+1
RABITEC DSR CAP 10	GEN.9+1
REACTIN 100SR 110 TAB 10	GEN.9+1
REACTIN 100SR 115 15	GEN.733+82
REACTIN 50TAB 10	GEN.9+1
REXCOF DX NF 100ML SYP(LARG) 100ML	GEN.9+1
REXCOF SOFTGELS 10	GEN.4+1
ROFFIXX-25MG TABS. 1X10	8+2
ROKO CAP 1	GEN.9+1
SPASMONIL TAB(CIPLA) 10	GEN.9+1
TADAFLO 20 10TAB	PCS4+2
TARIFLOX-OZ TAB 10	GEN.4+1
TOCODERM + 15GM OINT 1	GEN.4+1
TRIEXER 1 10TAB	PCS7+3
TRIEXER 2 10TAB	PCS7+3
TRIEXER 3 10TAB	PCS7+3
TRIEXER FORTE 1 10TAB	PCS7+3
TRIEXER FORTE 2 10TAB	PCS7+3
VANLID INJ. 1 VIAL	12+8
VITOMIN D3 GRANULES 1GM	PCS7+1
VOLTANEC-PR TABS. 1X10	4+1
VOMISTOP TAB 10	GEN.9+1
ZIPRAX-100 DT 1X10	TAB4+1
ZIPRAX-100MG DRY SYRUP 1X30ML	4+1
ZIPRAX-50 DRY SYP 1X30ML	4+1
AIRZ 50MG CAP 1X1PH	PCS10+3
ALEX (PLUS) PED DROP 15ml	Pcs11+1
ALEX COUGH LONG.TABS. 1X10	PCS10+1
ALEX P DROP 1X15ML	PH14+1
ALEX SUGAR FREE 1X50ML	PH14+1
ALEX SYP (60ML) 60ml	Pcs10+1
ALEX SYP.(L). 1X100M	PCS10+1
ALEX-(P) DROP 15ml	Pcs11+1
ALEX-P DROP 1X15ML	PCS10+1
ALEX-P SYP 1X60ML	PCS10+1
ALEX-PED.DROPS. 1X15ML	PCS10+1
ALEX-S/F 100ML SYP 1X100M	PCS10+1
ARTIGESIC SUS 60ML	Pcs9+1
ASCORIL D SY 1X100ML	PCS14+1
ASCORIL LS SYP 1X100ML	PCS14+1
ASCORIL SF SYP 100ML	Pcs14+1
ASCORIL SYRUPS 1X100ML	PH14+1
ASCORIL-LS 1X100	14+1
ASCORIL(LS-JUNIOR-60ML) 60ml	Pcs14+1
ASCORIL+EXPECT. 1X100M	14+1
AZIFINE 500 TABLET 5'S	Pcs5+1
AZIFINE XL SUSP 30ML	Pcs5+1
BONTRESS SERUM 60ML	Pcs10+1
BYE-LLERGY TAB 10's	Pcs5+1
CANDIBIOTIC DROPS 1X5ML	PCS11+1
CANDIBIOTIC E DROP(5ML) 5ML	Pcs14+1
CANDID B -30GM- 30gm	Pcs14+1
CANDID B CREAM 10GM 1X10GM	TUBE14+1
CANDID B CREAM 20GM 1X20GM	TUBE14+1
CANDID CREAM 50GM 50GM	Pcs14+1
CANDID DUSTIN POWDER 1X60GM	PCS14+1
CANDID DUSTING POWDER 1X120GM	PCS14+1
CANDID TOTAL CREAM 1X20GM	TUBE5+1
CANDID TOTAL PLUS 11TU	PC10+3
CANDID-B CREAM 1X10GR	14+1
CANDID-B CREAM 1X20GR	14+1
CANDID-MOUTH PAINT 1X15ML	10+1
CANDID-O EAR DROPS. 1X5ML	14+1
CANDID-POWDER {L}. 1X100G	11+1
CANDID-POWDER {S}. 1X50GR	11+1
CANDITRAL CAPS. 1X4	PCS10+3
CANDITZ 100MG 10'S	Pcs5+1
CANDITZ 200MG 10's	Pcs5+1
DIGHIHALER FB 200 11PH	PCS10+3
DIGIHALER IL 120 MDI 120 MDI	Pcs10+1
DIGIHALER SF 250 1X1PH	PCS10+3
DUBAGEST 300 CAP 10's	Pcs5+1
DUBAGEST SR-400MG 10's	Pcs5+1
DUBAGEST SR-400MG(10,S) 10,S	Pcs5+1
DUBAGEST-200 CAP (10,S) 10,S	Pcs3+1
DUBAGEST-SR 300MG (10,S) 10,S	Pcs5+1
ESOZ 40MG 15's	Pcs5+1
ESOZ-40MG CAPS. 115	PCS10+1
FLUCORT CREAM (20GM) 20GM	Pcs11+1
FLUCORT N CREAM (20GM) 20GM	Pcs11+1
GLEVO 500MG TABS 20X10	PCS9+1
GLEVO 750-(10'S) 10S	Pcs9+1
GLEVO-250 TAB 10's	Pcs9+1
GLEVO-500 TAB 10's	Pcs11+1
GLEVO-500MG TABS. 1X10	5+1
HAIR 4 U 10%(SPRAY)-60ML 60ML	Pcs5+1
I-FIN-500MG TAB 17	BOX9+1
IFIN 250 MG TAB 17	BOX9+1
IFIN 500 MG TAB 17	BOX9+1
KEFPOD -CV- 200 TAB 10,S	Pcs11+1
KEFPOD ORANGE-50mg SYP 30ml	Pcs11+1
LULIGEE LOTION (10ML) 10ML	Pcs5+1
MACLAR 250 TAB 10's	Pcs9+1
MACLAR 500 TAB 10's	Pcs11+1
MACLAR SYP 30ML	Pcs10+1
MILICLAV 228.5MG D/SYP 100ML	Pcs5+1
MILICLAV 625 TAB 10S	Pcs5+1
MILICLAV-625MG TABS. 1X6	5+1
MILIXIM 100MG 10's	Pcs10+1
MILIXIM DRY SYP 100MG 30ml	Pcs9+1
MILIXIM DRY SYP-50MG 30ml	Pcs9+1
MILIXIM-O-100DT 10's	Pcs9+1
MILIXIM-O-400SR 10's	Pcs9+1
MILIXIM-O-TAB 10's	Pcs9+1
MILIXIM-OZ-TAB 10's	Pcs10+1
MUCARYL LS DROP 15ml	Pcs9+1
MUCARYL LS JUNIOR SYP 60ml	Pcs9+1
NEB ZMART (DEVICE) 1's	Pcs2+1
ONABET (POWDER) 50GM	Pcs14+1
SCABOMA SOAP 75GM	Pcs9+1
SENSUR OIL 1X50ML	PCS14+1
SUNGRACE ULTRA 60 GM 60 GM	Pcs5+1
VC TONE PLUS GEL 15'ML	Pcs10+2
VORTHOVA TAB 10S	Pcs9+1
ALLERDEST 5MG TAB 1X10 TAB	PCS5+1
ALLERDEST M TAB 1X10 TAB	PCS11+1
ALPHADIN RF 15GM 1X15GM	TUB11+1
ANAFORTAN INJ 2ML	INJ9+1
ANASPAS AMPOULES 20X2ML	BOX9+1
ARACHITOL NANO 60K IU 1X30 ML	PHIL24+14
ARACHITOL NANO DAILY 2KIU 1X150 ML	PCS11+1
ASCABIOL 120 ML 1X1200 ML	PHIL19+1
ASCABIOL 120ML 120ML	SYR9+1
ASCABIOL 60 ML 1X60 ML	PHIL19+1
ASCABIOL 60ML 60ML	SYP19+1
AZRO 100 SYP 130ML	PCS5+1
AZRO 200 SYP 130ML	PCS9+1
AZRO 250 TAB 1X10 TAB	STIP9+1
AZRO 500 TAB 1X5 TAB	STIP9+1
BETONIN AST 400ML 1PIC	PHY15+1
BRUFEN POWER GEL 30 GM 1X30GM	PCS5+1
BRUFEN SPRAY 40GM	SPRA11+1
CAREX MV CAPS STRIPS 1X10	BOX11+1
CAREX MV SYRUP 100ML 1X100ML	PH11+1
CAREX RF PROTEIN POWDER 200GM 1X200GM	PH5+1
CEFCHAMP 325 1X10	STRI9+1
CEFI 200 TAB 1X10 TAB	PCS11+1
CEFI 50 DRY SUP 1X60 ML	PCS11+1
CEFI 50 DT 1X10 TAB	STIP11+1
CEFI DT 100 TAB 1X10 TAB	STIP11+1
CEFI O 200 MG DT 1X10TAB	PCS5+1
CEFI XL TAB 1X10	STRP5+1
CEFI-XL 100 TABS 12X10	BOX5+1
CEFI-XL 200MG TABS 12X10	BOX9+1
CEFI-XL TAB 1X10TAB	STIP11+1
CEROM 250MG TABS 12X10	BOX11+1
CEROM 500MG TAB 110TAB	PCS11+1
CEROM 500MG TABS 12X10	BOX11+1
CEROM 750 VAIL 1X1 VAIL	PCS1+1
CEROM CV 250MG TABS 12X6	BOX11+1
CEROM CV 500MG TABS 12X6	BOX11+1
CEROM CV TAB 500MG 16 TAB	STIP11+1
CEROM DRY SYP 130ML	PCS11+1
CEROM DRY SYRUPS 30ML 1X30ML	BOX11+1
CEROM SYP 1X30 ML	PHIL11+1
CREMAFIN FRESH TAB 1X10	STRO9+1
DELETUS LS 100ML	SYP10+1
DELETUS P 100ML	SYP10+1
DIGENE MINT GEL 200ML	SYP9+1
DIGENE ORANGE 450ML 450ML	SYP9+1
DIGENE ORANGE GEL 200ML	SYP9+1
DIGENE ORNAGE POND 1X450ML	PCS7+1
DIGENE SYRUPS 1X200ML	PH9+1
DIGENE TAB ORANGE 1X15	STRI5+1
DIGENE TABLET 20X15	BOX9+1
DUPHALAC BEAR 1.168 GM 1X1 BOX	BOXP5+1
ELECT-RTD LIQUID 1X200ML	PH23+4
ERTYCIN 100 SYRUP 1X15ML	PH11+1
ERTYCIN 200 SYRUPS 1X15ML	PH11+1
ERYTHROCIN 250MG TAB 1x10 TAB	STIP9+1
ERYTHROCIN 500 1X10	PCS9+1
ERYTHROCIN 500MG TAB 1x10 TAB	STIP9+1
ESGIPYRIN TAB 1X10	TAB11+1
ESGIPYRIN TABS 55X10	BOX10+1
FIGHTOX 375 TAB 1X10 TAB	STIP5+1
FIGHTOX 625 TAB 1X10 TAB	STIP5+1
FIGHTOX 625 TAB. 1X10 TAb	PCS5+1
FIGHTOX DRY SUY 1X30 ML	PCS11+1
FIGHTOX DRY SYP 30ML	PH84+16
FIGHTOX FORTE SYP 1X30 ML	PHIL5+1
FIGHTOX KID TAB 1X10	PCS11+1
FINCEF 1GM INJ 1PCS	INJ2+1
FINCEF 200 TAB 1X10 TAB	STIP11+1
FINCEF T 562.5 MG VAIL 1X1 VAIL	VAIL10+8
FINECEF 100 DRY SYP 1X1PH	PCS11+1
FINECEF 200MG TAB 110	TAB5+1
FINECEF 250 VAIL 1X VAIL	PCS10+9
FINECEF 250MG INJ 1PCS	INJ2+1
FINECEF 50 SYP 1X30 ML	PHIL11+1
FINECEF 500 MG VAIL 1 VAIL	PCS10+6
FINECEF CV 200 TAB 1X10 TAB	STIP5+1
FINECEF S 375 MG 1X1 VAIL	VAIL1+1
FINECEF-T 281.25 MG 1X1 VAIL	PCS10+9
GENTICYN 10ML INJ 1X10ML	Pcs11+1
GENTICYN 20MG PED INJ 1X2ML	AMP.11+1
KENACORT 4 MG TAB 1X15 TAB	PCS9+1
KENACORT-40ML INJ 40MG ML	PCS19+1
LIMCEE TAB 1X15 TAB	STIP10+1
LIVBEST-250MG TABS 12X10	BOX5+1
LIVBEST-500MG TABS 10X10	BOX5+1
LOBATE-GM OINT 1X15GM	TUBE7+1
MALATRIT-E AMP 1X2 ML	AMP1+1
MEGAMOX 125 DT TABS 10X10	BOX3+1
MEGAMOX 250 DT TABS 12X10	BOX3+1
MEGAMOX 500MG DT TABS 12X10	BOX3+1
MEGAMOX CV 30 SYP 30ML	PH11+1
MEGAMOX CV 375 TABS 10X6	BOX11+1
MEGAMOX CV 625 TABS 12X10	BOX5+1
MEGAMOX CV DRY SYRUP 30ML 1X30ML	PH11+1
MEGAMOX CV KID TABS 12X6	BOX11+1
MEGAMOX DRY SYRUPS 30ML 1X30ML	PCS23+2
MEGAMOX DX TABS 10X10	BOX11+1
MEXEF 375MG TABLS 12X10	PCS11+1
MEXEF DRY SYRUP 1X30ML	PH11+1
MEXEF-250 DT TAB 12X10	BOX11+1
MEXEF-500 DT TABLETS 10X10	BOX11+1
MEXEF-DS TABS 12X10	BOX11+1
NEBASULF POWDER 1X10GM	PCS19+1
NEW ERYTHOCIN 500 TAB 15X10	BOX9+1
NEW ERYTHOCIN 250 TAB 25X10	BOX9+1
NICOFER 300ML SYRUPS 1X300ML	BOX5+1
NICOFER XT TABS 10X7	BOX5+1
NIMUFLEX-P TAB 25X10	BOX3+1
PANDIFF 40 MG IV 1X1 VAIL	VAIL1+1
PANKREOFLAT SYP 200ML	SYP10+1
PARAXIN 500 CAP 1X10 CAP	STIP19+1
PARAXIN SYP 100ML	SYP9+1
PARAXIN SYP 1X100 ML	PHIL9+1
PARAXIN-250MG CAP 110 CAP	STIP19+1
PENTIDS 200 TAB 1X10 TAB	STIP19+1
PENTIDS 400 TAB 1X10 TAB	STIP19+1
PHENSEDYL DMR 100ML	SYP9+1
PHENSEDYL LR SYR 1X100ML	SYR9+1
PIRAFLOX 100MG TABS 10X10	BOX3+1
PIRAFLOX 200MG TABS 12X10	BOX3+1
PIRAFLOX 400MG TABS 10X10	BOX3+1
PIRAFLOX O IV INFUSION 100ML 1X100ML	PH1+1
PIRAZOLE CAPS 10X10	BOX11+1
POLYCROL FORTE GEL 1X170ML	PCS19+1
QUADRIDERM 5GM OINTMENT 1X5GM	PCS7+1
QUIET BR 100ML SYP 1X100ML	PH11+1
QUIET BR 60ML SYP 1X60ML	PH11+1
REBOOT DROPS 1X15ML	PH11+1
REBOOT M CAP 1X10	CAP10+3
REBOOT M SYRUPS 1X200ML	PH11+1
REZFURAN 100 MG 1X14 TAB	STIP11+1
REZFURAN 100 TAB 1X14 TAB	STIP11+1
SUGANRIL TABS 12X15	BOX10+1
SYMOXIL LB 250 CAP 20X10	PCS4+1
SYMOXIL LB 500 CAP 20X10	PCS4+1
TOPAC PLUS TABS 12X10	BOX3+1
TOPAC SP TABS 12X10	BOX3+1
TOSSEX SYRUP 1X100ML	PCS10+1
TRESMOX CV 1X10	TAB10+1
TRESMOX LB D CAPS 1X10	STRP10+1
TRUSTYL BR 100ML SYRUPS 1X100ML	PH11+1
TRUSTYL CD 60ML SYRUPS 1X60ML	PH5+1
TRUSTYL CD SYRUPS 100ML 1X100ML	PH11+1
TRUSTYL COLD 500 TABS STRIPS 1X10	BOX3+1
TRUSTYL COLD SYRUPS 60ML 1X60ML	PH3+1
TRUSTYL NASAL SPARY PAED 10ML 1X10ML	PCS11+1
TRUSTYL NASAL SPRAY ADULT 10ML 1X10ML	PH11+1
UDISYP SYP 1X200 ML	PHIL9+1
UPBEAT SYRUP 200ML 1X200ML	PH11+1
WYMOX 125MG KID TABS 10x15	BOX7+1
WYMOX 250 1X15	STRI11+1
WYMOX 250 DT TABS 10X15	BOX7+1
WYMOX 500MG CAPS 20X15	BOX11+1
WYMOX KID 125 MG 1X15 TAB	PCS11+1
WYMOX SYP 30ML	SYP9+1
ZIMNIC 50 TABS 12X10	BOX11+1
ZIMNIC AZ 250MG TABS 12X10	BOX5+1
ZIMNIC AZ KID TABS 12X10	BOX5+1
ZIMNIC AZ TABS 12X10	BOX5+1
ANCOOL SUSPENSION 170 ML	SYP5+1
AUGPEN DS SYP 130ML	PCS9+1
AUGPEN HS SP 130ML	PCS9+1
AUGPEN IV 150 MG 11VIAL	PCS5+1
AUGPEN IV 300 11VIAL	PCS2417+483
AUGPEN IV 600 11VIAL	PCS5+1
AUGPEN LB 1GM TAB 16	PCS5+1
AUGPEN LB 375 TAB 16	PCS5+1
AUGPEN LB 625 TAB 16	PCS9+2
AUGTAX-375MG INJ. 1 VIAL	10+1
BEVON CAP 115	PCS100+11
BEVON DROP 15 ML	DROP10+1
BEVON SOFTULES 110	STRP5+1
BEVON SOFTULES 1X15	PCS9+1
BEVON SUSPENSION 200 ML 200 ML	SYP5+1
BEVON SYS 1100ML	PCS100+11
BRAIN MAX	TAB.9+1
C-TAX O FORTE DRY SYRUP 50 ML 50 ML	STRP5+1
C-TAX OF TABLETS 110	TAB.5+1
CORALIUM D3 TAB 120'	PCS5+1
CORALIUM D3 TABLET 120	STRP5+1
CORTIMAX 24 MG 110	TAB.5+1
CTAX O 100 DT TAB 110TAB	PCS19+2
CTAX O 200 DT TAB 110	PCS0+22
CTAX O 50 DT TAB 110	PCS9+1
CTAX O SP 130ML	PCS9+1
CTRI 125 INJ 11VIAL	PCS9+1
CTRI 1GM INJ 11VIAL	PCS5+1
CTRI 250 INJ 11VIAL	PCS10+3
CTRI 500 INJ 11VIAL	PCS5+1
EMIGO SUSP. 1X30ML	9+1
ENOXARIN-40 INJ 11	PCS5+1
ENOXARIN-60 INJ 11	PCS0+6
ETOSPEED 90 TABLET 1010	STRP5+1
EUCALMIN CAPSULES 110	STRP5+1
FERONIA D3 TABLETS 13	STRP5+1
FERONIA XT TABLET 110	STRP5+1
FERONIA-XT SUSPENSION 150 ML	SYP10+1
FLORISTORE 2.5 CAPSULE 110	STRP10+1
FULL 365 CAP 110	TAB.5+1
GATOR 200 TAB 15	PCS9+1
GATOR 400 TAB 15	PCS9+1
LORNIT INJ. 1X10ML	9+1
MAXTRA DP 115ML	PCS9+1
MAXTRA GARGLE 120 ML 120 ML	SYP10+1
MAXTRA ORAL DROP 15 ML 110	DROP5+1
MAXTRA P DROPS 115ML	PCS9+1
MAXTRA P ORAL DROPS 15 ML 110	DROP5+1
MAXTRA P SYP 60 ML 60 ML	SYP5+1
MAXTRA S NASAL SPRAY 20 ML 110	SPRY10+1
MAXTRA SP 160ML	PCS154+17
MAXTRA SYP 60 ML 60 ML	SYP5+1
MAXTRA TAB 110TAB	PCS9+1
MAXTRA-P DROPS. 1X15ML	9+1
MAXTRA-P SUSP 160ML	PCS9+1
MAXTRA-P SYRUP. 1X60ML	9+1
MAXTRA-P TAB 110	PCS9+1
MECOVON OD CAPSULES 110	TAB.5+1
MONOBACT 1 5GM INJ 11	PCS9+1
MONOBACT 375 INJ 11	PCS0+150
MONOBACT 750 INJ 11	PCS9+1
MONOBACT KID INJ 125 1VAIL	PCS9+1
MONOBACT-375MG INJ. 1 VIAL	9+1
MYOTOP 150 TABLET 110	STRP5+1
MYOTOP D TABLET 110	STRP10+1
MYOTOP P TABLET 110	STRP5+1
MYOTOP-450 SR TABLETS 15	STRP5+1
MYOTOP-DSR TABLET 110	STRP5+1
NEW NORMET SUSPENSION 60 ML	SYP10+1
NORMET TABLET 110	STRP5+1
PANSA IV 11VIAL	PCS5+1
PEGCLEAR SYRUP 200 ML 200 ML	SYP10+1
PLATFAST TABLET 110	STRP10+1
PRO-DIOF LIQUID 30 ML 125	SYP10+1
RABIFAST-DSR CAPS. 1X10	10+1
SCAVISTA 12 MG TABLET 120	STRI9+1
SERETRA 80 TABLETS 110	TAB.10+2
SETOLAC 300 ER TABLETS 110	STRI5+1
SOVENTUS DX SYRUP 100 ML	SYP.5+1
SOVENTUS JR SYRUP 60 ML	SYP5+1
SOVENTUS SP 1100ML	PCS10+1
SOVENTUS-D SYP 1100ML	PCS10+1
SOVENTUS-D SYRUP 100 ML 100 ML	SYP9+1
SOVENTUS-JR SYP 160ML	PCS10+1
TENDOFIRM CAPSULES 115	STRP10+1
TOBASAFE EYE DROP 15ML	PCS21+4
URSOMAX 450 SR 110	TAB.5+1
VITANOVA D3 SG CAPSULES 14	STRP10+1
VITANOVA-D3 DROPS 15 ML 115 ML	DROP10+1
VITANOVA-D3 SACHET 11	SACH10+1
ZEOF-O TABS. 1X10	9+1
ZINCONIA 50 TABLET 110	STRP9+1
ZINCONIA SYRUP 100 ML 100 ML	SYP10+1
ZOSTUM 1GM INJ 11VIAL	PCS9+1
ZOSTUM 500MG INJ 11VIAL	PCS9+1
ZOSTUM O 100 DRY SUSPENSION 130 ML	SYP10+1
ZOSTUM O TABLET 110	STRP10+1
ZOSTUM-2GR. INJ. 1 VIAL	9+1
ARGIHOPE SACHET 5GM	SACH5+1
B 29 SYP 200ML	SYPT10+1
B29 GOLD AQ INJ 2ML	INJ4+1
DILO BM SYP 100ML	SYP10+1
DILO DX SYP 100ML	SYP10+1
FUNZI IT 100 1X4	CAP5+1
FUNZI IT 200 1X4	TAB5+1
FUNZI L CREAM 30GM	CRE10+1
FUNZI MX POWDER 75GM	POWD5+1
FUNZI NM CREAM 15GM	CREA5+1
FUNZI NM LOTION 30ML	LOTI10+1
FUNZI TAB 10S	Pcs5+1
FUNZI-IT-100 CAP 110	PCS10+1
FUNZI-NM CREAM 20GM	CRE5+1
MAC RD CAP 1X10	CAP10+1
RESPICURE D SYP 100ML	SYP9+1
RESPICURE LS DROP 15ML	DROP9+1
RESPICURE LS SYP 100ML	SYP9+1
RESPICURE M SYP 60ML	SYP9+1
RESPICURE M TAB 1X10	STRI9+1
RESPICURE SYP 60ML	SYP9+1
STIMULET 5 1X5	STRI9+1
STIMULET(2.5)MG TAB 5S	Pcs5+1
TAMDOSIN 4 1X10	PCS5+1
ULPAN D 1X10	STRI10+1
ULPAN DSR 1X10	CAP10+1
ULPAN GEL 200ML	SYP9+1
ULPAN SYP 170ML	Pcs9+1
VITNEURIN AQ INJ 1VIAL	INJ9+1
VITNEURIN SYP 100ML	SYP10+1
XITH 500MG 3TAB	Pcs4+1
XOCLAVE 375MG TAB 10S	Pcs9+1
XOCLAVE 625 1X10	TAB5+1
XOCLAVE DRY SYP 30ML	Pcs9+1
XOCLAVE DRY SYP 30ML	SYP9+1
XOCLAVE DUO DRY SYP 30ML	Pcs10+1
XOCLAVE DUO SYP 30ML	SYP9+1
ASWAL PLUS CAPSULES 1X10	5+1
AZNEE-250MG 1X6	5+1
AZNEE-500MG 1X3	5+1
AZNEE-SYP 100MG 1X15ML	5+1
AZNEE-SYP 200MG 1X15ML	5+1
EUGYNIN-L TABS. 1X10	5+1
FLABONE CAPS. 1X10	5+1
GLX-INJ. 1XVIAL	5+1
GLX-MR PLUS 1X10	5+1
GLX-MR TABS. 1X10	PCS9+1
GLX-MR TABS. 1X10	9+1
GLX-P TABS. 1X10	9+1
IMUNOCIN-SYP 1X100M	5+1
KOFEND COUGH SYP 1X100M	10+4
LAXIVE-POW. 1X100G	5+1
LIVPAR LIVER TONIC 1X200	5+1
LIVPAR TABS. 1X50	5+1
LOTRIL-BG SKIN CREAM 1X15G	5+1
LOTRIL-POW. 1X30GM	5+1
LOTRIL-POW. 1X30GM	PCS5+1
LOTRIL-SOLUTION 1X15ML	5+1
LOTRIL-SOLUTION 1X15ML	PCS9+1
MENOGIA-INJ. 1X5ML	200+190
NUCART-OA TABS. 1X12	5+1
OLIN-4.5GM INJ. 1X4.5G	9+11
OPTIFER-XT TABS. 1X10	5+1
PRODOX-100 DT 1X10	5+1
PRODOX-200 DT 1X10	10+1
PRODOX-50 DT 1X10	5+1
PRODOX-50 DT 1X10	PCS5+1
PRODOX-SYP 1X30ML	5+1
RABOL-20MG INJ. 1XVAIL	13+7
RABOL-20MG TABS. 1X10	5+1
RABOL-D CAPS. 1X10	5+1
RIDOL-OZ TABS. 1X10	5+1
SALLAKI LINIMENT OIL. 1X60ML	5+1
SALLAKI OINT. 1X30GM	5+1
SALLAKI-600MG TABS. 1X10	5+1
SALLAKI-MR TABS. 1X10	5+1
SALLAKI-PLUS TABS. 1X10	5+1
VIPRO-FE SYP. 1X200M	10+4
ZAD-G OINT. 1X100G	9+1
ZAD-G OINT.(S) 1X15GM	9+1
AZILIDE 500MG TABS 15X3	BOX5+1
AZILIDE-DT TAB 20X3	PCS10+1
BACTOCLAV DRY SYRUP 1X30ML	5+1
BICEF-125DT TABS. 1X10	6+0
BIOVITAL CAPS. 1X10	5+1
DOLO-650 110	PCS5+1
DOLOWIN FORTE 110	PCS10+1
DOLOWIN PLUS 110	PCS10+1
DYNAPAR AQ AMP 50X1ML	BOX5+1
ESOFAG D 110	ST10+1
ESOFAG-40MG CAP 10	BOX10+1
ESOFAG-L CAP 110	BOX10+1
FEROX-XT CAPS. 1X6	10+1
FULGEST-100MG CAPS. 1X10	10+3
LEVOBACT-500MG TABS 30X5	BOX10+1
MICROCEF-200DT TABS. 1X10	10+1
MICROCEF-CV 200MG TABS 1X10	10+1
MICRODOX-LBX 1X10	11+1
MICROTAZ 4.5.INJ. 1VIAL	10+4
NOVOLID-PLUS TABS. 1X10	5+1
OMICAP CAP 10X20	BOXP1+1
RITE-O-CEF 200MG TABS 10X10	PCS10+1
TENEPRIDE-M-1000MG 1010	PCS10+1
TRIPRIDE-2MG 3015	PCS10+1
VENTRYL EXP. 1X60ML	10+1
VENTRYL-SYP 100ML 1X100M	10+1
CIFRAN I.V. 1X100M	10+3
CIFRAN-250MG TABS. 1X10	2+1
CIFRAN-500MG TABS. 1X1030	STRP2+1
CIFRAN-500MG TABS. 30X10	BOX19+1
CIFRAN-CT TABS. 1X10	7+3
CIFRAN-OZ TABS. 1X10	9+1
MOX-125MG KID TABS. 30X15	BOX5+1
MOX-125MG TABS. 1X15	5+1
MOX-250MG CAPS. 20X15	BOX9+1
MOX-250MG KID TABS. 30X15	BOX9+1
MOX-500MG CAPS. 20X15	BOX9+1
MOX-CV 625 TAB. 1X10	BOX9+1
MOX-KID 250MG TABS. 1X15	5+1
MOX-REDIMIX 125MG SYRUP. 1X60ML	16+1
OFRAMAX FORTE 1.5 INJ. 1 VIAL	10+4
OFRAMAX-1GM INJ. 1 VIAL	10+6
PEPFIZ TAB 12	Pcs9+1
SUPRIMOX-500MG CAPS. 1X15	11+1
VOLINI GEL 10GM	Pcs11+1
VOLINI GEL 15GM 115GM	Pcs11+1
VOLINI GEL 30GM 130GM	Pcs11+1
VOLINI GEL 4GM 15GM	Pcs11+1
VOLINI GEL 50GM 150GM	Pcs11+1
VOLINI GEL 75GM 175GM	Pcs11+1
VOLINI GELL 15GM 15GM	TUB11+1
VOLINI GELL 30GM 130	TUB11+1
VOLINI SPRAY 15GM 1	Pcs11+1
VOLINI SPRAY 40GM 140GM	Pcs11+1
VOLINI SPRAY 60GM 160GM	Pcs11+1
VOLINI-GEL (S) 1X10GM	PCS11+1
VOLINI-GEL.[B] 1X30GR	PCS11+1
VOLINI-SPRAY.(B). 1X55GR	11+1
VOLINI-SPRAY.(S). 1X35GR	11+1
ZIFEXIM 200 TAB. 10X10	BOX11+1
CTAX-O 50DT TABS. 1X10	9+1
EMLUZ CREAM 10GM	PCS10+1
EMSULIDE-P TABS. 1X10	9+1
ETS-100MG TABS. 1X10	10+1
ETS-200MG CAPS. 1X10	10+1
FULL 24 INJ 5X1VIL	PCS9+1
FULL 24 SUSP 1X100ML	PCS9+1
MAXTRA DROPS. 1X15ML	9+1
MAXTRA SYRUP. 1X60ML	9+1
NORMET TABS. 1X10	10+1
NUSAR 25 MG 1X10	PCS10+1
NUSAR AM 5 TAB 1X10	PCS9+1
OROFER S INJECTION 2.5ML	PCS9+1
OROFER-S INJ. 1X2.5M	9+1
PAUSE INJ. 1X5ML.	5+1
XPLODE-POWDER. 1X200G	5+1
CYNOCAL(NS) SYP 200ML	Pcs10+1
D.F.O.GEL. 1X30GM	PCS9+1
D.F.O.GEL. 1X30GR	9+1
TRANOSTAT INJ. 1X5ML	9+1
FEPANIL 125 MG SYP 1	BOTT10+1
FEPANIL 500 MG TAB 1X10 TAB	STRI5+1
FEPANIL 650 MG TAB 1X10 TAB	STRI5+1
LYSATONE PLUS SYP. 1X300M	5+1
KETAMIN-50ML VIAL. 1X10ML	4+1
LUMETHER FORTE DT 1X6T	5+1
LUMETHER KID SYP 1X15ML	PCS10+3
LUMITHER DT TAB 1X8	PCS5+1
TETRA-COX TAB 10T	10+1
THEMIBUTOL 600 MG TAB 1X10	PCS5+1
THEMIBUTOL PLUS -1000 TAB 1X10	PCS9+1
THEMIBUTOL-600MG TABS. 1X10	10+1
TOLPIDOL OD TAB 1X6	PCS10+1
TRICOX TAB 10T	10+1
`;

export const parseSchemeMedicineExcelData = () => {
    const rows = SCHEME_MEDICINE_LIST.trim().split('\n'); // Split by new lines
    const headers = rows.shift().split('\t'); // Extract headers
    const result = rows.map((row, index) => {
        const [ProductName, ProductScheme] = row.split('\t'); // Split by tabs
        return {
            _id: index + 1,
            ProductName,
            ProductScheme
        };
    });
    return result;
}
